export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A JSON scalar */
  JSON: { input: any; output: any; }
  /** A 64-bit signed integer */
  Long: { input: any; output: any; }
};

/** Activity tracking entity for canonical, deduped interactions */
export type Activity = BaseEntity & {
  __typename?: 'Activity';
  actorPersonId?: Maybe<Person>;
  canonicalActivityName?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  dedupKey?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  externalRefs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  model?: Maybe<Scalars['String']['output']>;
  participantsContactIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  participantsPersonIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  signalType?: Maybe<Scalars['String']['output']>;
  sourceEventType?: Maybe<Scalars['String']['output']>;
  sourceTool?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['Long']['output']>;
  subjectIds?: Maybe<Array<Maybe<BaseEntity>>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type ActivityInput = {
  actorPersonId?: InputMaybe<Scalars['ID']['input']>;
  canonicalActivityName?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  dedupKey?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  externalRefs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  participantsContactIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  participantsPersonIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  signalType?: InputMaybe<Scalars['String']['input']>;
  sourceEventType?: InputMaybe<Scalars['String']['input']>;
  sourceTool?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['Long']['input']>;
  subjectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a ActivityList query */
export type ActivityListResult = {
  __typename?: 'ActivityListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Activity>>>;
  /** Total number of Activity records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Outcome of addOrgChangeItems: the saved draft plus what happened to each submitted item, so merges and no-op drops are visible instead of silent. */
export type AddOrgChangeItemsResult = {
  __typename?: 'AddOrgChangeItemsResult';
  /** Items appended as new entries */
  added: Scalars['Int']['output'];
  /** The draft after the add */
  changeSet: OrgChangeSet;
  /** Items dropped because the requested value is already live */
  dropped: Scalars['Int']['output'];
  /** Items reconciled into an existing item on the same entity+field */
  merged: Scalars['Int']['output'];
  /** Items skipped because an admin dismissed the identical change within the suppression window (AGENT lane only; always 0 elsewhere) */
  suppressed: Scalars['Int']['output'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

/** One row of the Actions queue — shared chrome plus the artifact it stands for */
export type AgentActionCard = {
  __typename?: 'AgentActionCard';
  /** The agent that produced this (a workflow's code for a headless run), or null when a person drafted it */
  agentCode?: Maybe<Scalars['String']['output']>;
  /** That agent's or workflow's display name as it was when it ran */
  agentName?: Maybe<Scalars['String']['output']>;
  /** The org change set, when kind is CHANGE_SET */
  changeSet?: Maybe<OrgChangeSet>;
  /** The session this came out of — a conversation to open with agentChat, or a workflow run's record. Null for a hand-drafted change set or a session that was somebody else's. */
  chatId?: Maybe<Scalars['ID']['output']>;
  /** The agent draft, for every other kind */
  draft?: Maybe<Agent_Draft>;
  /** Document id of the artifact — also this row's identity */
  id: Scalars['ID']['output'];
  /** CHANGE_SET, or the kind of draft (BRIEFING) — decides which body is populated */
  kind: Scalars['String']['output'];
  /** How this came to exist: CHAT (a person talked an agent into it), WORKFLOW (a person ran a workflow now — see workflowCode), ROUTINE (a routine fired — see routineId; it ran as its owner), SYNC (the HRIS feed), or MANUAL (an admin drafted it by hand). In every case but SYNC, createdBy on the artifact is the person. Badge from this instead of re-deriving it from other fields. */
  origin: Scalars['String']['output'];
  /** Where the review button goes, when the artifact has its own screen; null for a draft that is read in the card itself */
  reviewUrl?: Maybe<Scalars['String']['output']>;
  /** The routine whose firing produced this — matches routineId in the routines list. Null for a conversation or a Run-now. */
  routineId?: Maybe<Scalars['ID']['output']>;
  /** The artifact's own status — DRAFT for a change set, OPEN for a draft */
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** Last touched, epoch millis — what the queue is ordered by */
  updatedAt?: Maybe<Scalars['Long']['output']>;
  /** The workflow a headless run executed — matches a code in workflowLibrary. Null for a conversation. */
  workflowCode?: Maybe<Scalars['String']['output']>;
};

/** Paginated result of an agentActions query */
export type AgentActionListResult = {
  __typename?: 'AgentActionListResult';
  /** Whether more actions exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<AgentActionCard>>;
  /** Total number of open actions visible to this caller */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** One conversational agent as shown in the picker */
export type AgentChatAgent = {
  __typename?: 'AgentChatAgent';
  /** Avatar settings, stored and served verbatim — the FE generates the face from them. Null means seed it from code. */
  avatar?: Maybe<Scalars['JSON']['output']>;
  /** Stable code; pass to startAgentChat */
  code: Scalars['String']['output'];
  /** The person who built a TENANT agent — its owner; null for PLATFORM */
  createdBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  /** Text of the execute button for this agent; null for a chat-only agent (resultKind NONE), which has no button — its conversation is the product */
  executeLabel?: Maybe<Scalars['String']['output']>;
  /** Kind of artifact this agent produces (e.g. CHANGE_SET) */
  resultKind?: Maybe<Scalars['String']['output']>;
  /** PLATFORM for an out-of-the-box agent (read-only in the UI: no edit, no delete); TENANT for one authored in this workspace, whose document is in tenantAgents and whose author may edit it there */
  source: Scalars['String']['output'];
  /** The agent's own prompt chips: shown on the picker, and under any reply whose turn wrote no follow-ups of its own */
  suggestedPrompts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Codes of the workflows attached to this agent — the job the execute button runs. Empty for agents that only converse. */
  workflows?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** One workflow as shown in the Workflows tab — a unit of work that can be run on its own (runWorkflow) or by the agent that attaches it */
export type AgentWorkflow = {
  __typename?: 'AgentWorkflow';
  /** Library group (ORG, HR, …) — contributed by the owning module */
  category: Scalars['String']['output'];
  /** Stable code; pass to runWorkflow */
  code: Scalars['String']['output'];
  /** Author's Person ref for a TENANT card; null for PLATFORM */
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  /** Typed inputs, in declaration order: [{name, type, required, default, description}] — the Run-now form */
  inputs?: Maybe<Scalars['JSON']['output']>;
  /** True when a run's result is information kept as an Agent_Draft in Actions; false when it is a reviewable change in its own flow */
  producesBriefing: Scalars['Boolean']['output'];
  /** Permission a run needs; the library is already filtered by it */
  requiredPermission?: Maybe<Scalars['String']['output']>;
  /** Kind of artifact one run produces (CHANGE_SET, BRIEFING, …) */
  resultKind: Scalars['String']['output'];
  /** PLATFORM (shipped in a module) or TENANT (authored by the caller). Only TENANT cards can be edited — by their author */
  source: Scalars['String']['output'];
  /** Cron hint pre-filled when the caller saves a routine of this workflow; not a routine itself */
  suggestedCron?: Maybe<Scalars['String']['output']>;
  /** The file's own number from its frontmatter, default 1 */
  version?: Maybe<Scalars['Int']['output']>;
};

/** One agent action intent with the governance verdict; the agent action ledger and approval queue */
export type Agent_Action = BaseEntity & {
  __typename?: 'Agent_Action';
  actionType?: Maybe<Scalars['String']['output']>;
  agentCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  decidedAt?: Maybe<Scalars['Long']['output']>;
  decidedBy?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  dispatchMode?: Maybe<Scalars['String']['output']>;
  dispatchedAt?: Maybe<Scalars['Long']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  executedAt?: Maybe<Scalars['Long']['output']>;
  executionError?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  model?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Scalars['JSON']['output']>;
  resultRef?: Maybe<Scalars['String']['output']>;
  runId?: Maybe<Scalars['String']['output']>;
  subjectId?: Maybe<BaseEntity>;
  subjectType?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  verdict?: Maybe<Scalars['String']['output']>;
  verdictReason?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type Agent_ActionInput = {
  actionType?: InputMaybe<Scalars['String']['input']>;
  agentCode?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  decidedAt?: InputMaybe<Scalars['Long']['input']>;
  decidedBy?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dispatchMode?: InputMaybe<Scalars['String']['input']>;
  dispatchedAt?: InputMaybe<Scalars['Long']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  executedAt?: InputMaybe<Scalars['Long']['input']>;
  executionError?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  payload?: InputMaybe<Scalars['JSON']['input']>;
  resultRef?: InputMaybe<Scalars['String']['input']>;
  runId?: InputMaybe<Scalars['String']['input']>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
  subjectType?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  verdict?: InputMaybe<Scalars['String']['input']>;
  verdictReason?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a Agent_ActionList query */
export type Agent_ActionListResult = {
  __typename?: 'Agent_ActionListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Agent_Action>>>;
  /** Total number of Agent_Action records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** One turn of an agent chat transcript — a child document of its Agent_Chat_Session */
export type Agent_Chat_Message = BaseEntity & {
  __typename?: 'Agent_Chat_Message';
  agentCode?: Maybe<Scalars['String']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  feedback?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  role?: Maybe<Scalars['String']['output']>;
  seq?: Maybe<Scalars['Int']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

/** One conversational agent session — transcript, execution state, and the produced result */
export type Agent_Chat_Session = BaseEntity & {
  __typename?: 'Agent_Chat_Session';
  agentCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  dryRun?: Maybe<Scalars['Boolean']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  executedAt?: Maybe<Scalars['Long']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  memoryCompactedThroughSeq?: Maybe<Scalars['Int']['output']>;
  memorySummary?: Maybe<Scalars['String']['output']>;
  /** The transcript, oldest first — the session's Agent_Chat_Message child documents, fetched only when this field is selected */
  messages?: Maybe<Array<Maybe<Agent_Chat_Message>>>;
  readyToExecute?: Maybe<Scalars['Boolean']['output']>;
  result?: Maybe<Scalars['JSON']['output']>;
  routineId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subjectRef?: Maybe<Scalars['String']['output']>;
  suggestions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  titledByUser?: Maybe<Scalars['Boolean']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
  workflowCode?: Maybe<Scalars['String']['output']>;
  workflowInputs?: Maybe<Scalars['JSON']['output']>;
  workflowVersion?: Maybe<Scalars['Int']['output']>;
};

/** An agent's reviewable work product that changes nothing — a briefing, an outline — listed in Actions alongside org change sets */
export type Agent_Draft = BaseEntity & {
  __typename?: 'Agent_Draft';
  agentCode?: Maybe<Scalars['String']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  chatId?: Maybe<Scalars['String']['output']>;
  counts?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  reviewComment?: Maybe<Scalars['String']['output']>;
  routineId?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
  subjectRef?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
  workflowCode?: Maybe<Scalars['String']['output']>;
  workflowVersion?: Maybe<Scalars['Int']['output']>;
};

/** Defines a single aggregate expression (e.g. COUNT(*) AS total) */
export type AggregationInput = {
  /** Output alias for this aggregate column */
  alias: Scalars['String']['input'];
  /** Aggregate expression, e.g. "COUNT(*)", "SUM(c.amount)", "MAX(c.amount)" */
  expr: Scalars['String']['input'];
};

export type AnalyticsDashboard = BaseEntity & {
  __typename?: 'AnalyticsDashboard';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  dashboardType?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  globalFilters?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  tenantId?: Maybe<Scalars['String']['output']>;
  tiles?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type AnalyticsDashboardInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  dashboardType?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  globalFilters?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  tiles?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a AnalyticsDashboardList query */
export type AnalyticsDashboardListResult = {
  __typename?: 'AnalyticsDashboardListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<AnalyticsDashboard>>>;
  /** Total number of AnalyticsDashboard records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AnalyticsView = BaseEntity & {
  __typename?: 'AnalyticsView';
  chart?: Maybe<Scalars['JSON']['output']>;
  columns?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  /** Number of dashboards referencing this view */
  dashboardCount?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  filter?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  reportDefinitionId?: Maybe<ReportDefinition>;
  sort?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type App_Role = BaseEntity & {
  __typename?: 'App_Role';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  parentRoleId?: Maybe<App_Role>;
  systemDefined?: Maybe<Scalars['Boolean']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type App_RoleInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  parentRoleId?: InputMaybe<Scalars['ID']['input']>;
  systemDefined?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Artifact entity for tracking documents and files */
export type Artifact = BaseEntity & {
  __typename?: 'Artifact';
  activityId?: Maybe<Activity>;
  artifactRef?: Maybe<Scalars['String']['output']>;
  artifactType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  ownerPersonId?: Maybe<Person>;
  subjectIds?: Maybe<Array<Maybe<BaseEntity>>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type ArtifactInput = {
  activityId?: InputMaybe<Scalars['ID']['input']>;
  artifactRef?: InputMaybe<Scalars['String']['input']>;
  artifactType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  ownerPersonId?: InputMaybe<Scalars['ID']['input']>;
  subjectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a ArtifactList query */
export type ArtifactListResult = {
  __typename?: 'ArtifactListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Artifact>>>;
  /** Total number of Artifact records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** One actor's enrolment in a productivity model */
export type AssignedActor = {
  __typename?: 'AssignedActor';
  /** The actor's composite doc key — pass it straight to Person(id:) or JobProfile(id:) to render a name */
  actorId: Scalars['ID']['output'];
  /** Person or JobProfile. Null only for a legacy row whose actorId is not a composite key — that actor is in no population and is scored by nothing, so it is listed to be seen and replaced */
  actorType?: Maybe<Scalars['String']['output']>;
  /** The model the actor is enrolled in */
  productivityModel: Scalars['String']['output'];
  /** The role they perform, naming one of that model's roles[] */
  productivityRole: Scalars['String']['output'];
};

export type Audit_Log = {
  __typename?: 'Audit_Log';
  action?: Maybe<Scalars['String']['output']>;
  actor?: Maybe<User>;
  actorUserId?: Maybe<Scalars['String']['output']>;
  app?: Maybe<Scalars['String']['output']>;
  changes?: Maybe<Array<Maybe<FieldChange>>>;
  host?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  occurredAt?: Maybe<Scalars['Long']['output']>;
  targetEntityType?: Maybe<Scalars['String']['output']>;
  targetId?: Maybe<Scalars['String']['output']>;
  thread?: Maybe<Scalars['String']['output']>;
};

/** Common fields shared by all entity types. Use inline fragments (e.g. '... on Account { name }') to access type-specific fields. */
export type BaseEntity = {
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type BrowserUploadSession = {
  __typename?: 'BrowserUploadSession';
  expiresAt?: Maybe<Scalars['Long']['output']>;
  requiredHeaders?: Maybe<Scalars['JSON']['output']>;
  sessionId: Scalars['ID']['output'];
  uploadMode: Scalars['String']['output'];
  uploadUrl?: Maybe<Scalars['String']['output']>;
};

/** A career ladder system, scoped to one or more job family groups */
export type CareerFramework = BaseEntity & {
  __typename?: 'CareerFramework';
  appliesTo?: Maybe<Array<Maybe<JobFamilyGroup>>>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type CareerFrameworkInput = {
  appliesTo?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** One rung on a career track: its grade, its expectations, its entry bar, and its outbound moves */
export type CareerLevel = BaseEntity & {
  __typename?: 'CareerLevel';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  entryCriteria?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  expectations?: Maybe<Scalars['String']['output']>;
  expectedQualifications?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  expectedSkills?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  id: Scalars['ID']['output'];
  isTop?: Maybe<Scalars['Boolean']['output']>;
  jobGrade?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  managementScope?: Maybe<Scalars['String']['output']>;
  productivityModel?: Maybe<Scalars['String']['output']>;
  productivityRole?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  trackId?: Maybe<CareerTrack>;
  transitions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type CareerLevelInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  entryCriteria?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  expectations?: InputMaybe<Scalars['String']['input']>;
  expectedQualifications?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  expectedSkills?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isTop?: InputMaybe<Scalars['Boolean']['input']>;
  jobGrade?: InputMaybe<Scalars['String']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  managementScope?: InputMaybe<Scalars['String']['input']>;
  productivityModel?: InputMaybe<Scalars['String']['input']>;
  productivityRole?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  trackId?: InputMaybe<Scalars['ID']['input']>;
  transitions?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** One named ladder within a career framework */
export type CareerTrack = BaseEntity & {
  __typename?: 'CareerTrack';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  frameworkId?: Maybe<CareerFramework>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type CareerTrackInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  frameworkId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

export type CellError = {
  __typename?: 'CellError';
  column?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  rowIndex?: Maybe<Scalars['Int']['output']>;
  sheet?: Maybe<Scalars['String']['output']>;
};

/** Accumulator for incomplete chat channel batches */
export type ChatBucket = BaseEntity & {
  __typename?: 'ChatBucket';
  attachments?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  channelId?: Maybe<Scalars['String']['output']>;
  combinedMessageText?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  messageCount?: Maybe<Scalars['Int']['output']>;
  rawChatIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  source?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type ChatBucketInput = {
  attachments?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  channelId?: InputMaybe<Scalars['String']['input']>;
  combinedMessageText?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  messageCount?: InputMaybe<Scalars['Int']['input']>;
  rawChatIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  source?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a ChatBucketList query */
export type ChatBucketListResult = {
  __typename?: 'ChatBucketListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<ChatBucket>>>;
  /** Total number of ChatBucket records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Tenant root — carries AI calibration context and OKR cycle configuration */
export type Company = BaseEntity & {
  __typename?: 'Company';
  businessModel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  defaultAmbitionLevel?: Maybe<Scalars['String']['output']>;
  defaultCurrency?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  emailDomains?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  fiscalYearStartMonth?: Maybe<Scalars['Int']['output']>;
  foundedYear?: Maybe<Scalars['Int']['output']>;
  geographiesServed?: Maybe<Array<Maybe<Location>>>;
  growthStage?: Maybe<Scalars['String']['output']>;
  headcountRange?: Maybe<Scalars['String']['output']>;
  headquartersLocation?: Maybe<Location>;
  headquartersTimezone?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  keyProducts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  legalName?: Maybe<Scalars['String']['output']>;
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  notableClients?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  okrCadence?: Maybe<Scalars['String']['output']>;
  registeredAddress?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  workLocations?: Maybe<Array<Maybe<Location>>>;
  workMode?: Maybe<Scalars['String']['output']>;
};

export type CompanyInput = {
  businessModel?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  defaultAmbitionLevel?: InputMaybe<Scalars['String']['input']>;
  defaultCurrency?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  emailDomains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  fiscalYearStartMonth?: InputMaybe<Scalars['Int']['input']>;
  foundedYear?: InputMaybe<Scalars['Int']['input']>;
  geographiesServed?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  growthStage?: InputMaybe<Scalars['String']['input']>;
  headcountRange?: InputMaybe<Scalars['String']['input']>;
  headquartersLocation?: InputMaybe<Scalars['ID']['input']>;
  headquartersTimezone?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  keyProducts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  notableClients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  okrCadence?: InputMaybe<Scalars['String']['input']>;
  registeredAddress?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  workLocations?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  workMode?: InputMaybe<Scalars['String']['input']>;
};

/** A knowledge entry in the company knowledge graph — feeds the OKR generation LLM pipeline */
export type CompanyKnowledge = BaseEntity & {
  __typename?: 'CompanyKnowledge';
  FIELD_KG_EXTRACTED_AT?: Maybe<Scalars['String']['output']>;
  FIELD_KG_EXTRACTION_STATUS?: Maybe<Scalars['String']['output']>;
  KG_STATUS_DONE?: Maybe<Scalars['String']['output']>;
  KG_STATUS_FAILED?: Maybe<Scalars['String']['output']>;
  KG_STATUS_PENDING?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kgExtractedAt?: Maybe<Scalars['Long']['output']>;
  kgExtractionStatus?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  source?: Maybe<Scalars['String']['output']>;
  sourceDate?: Maybe<Scalars['Long']['output']>;
  sourceRef?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type CompanyKnowledgeInput = {
  FIELD_KG_EXTRACTED_AT?: InputMaybe<Scalars['String']['input']>;
  FIELD_KG_EXTRACTION_STATUS?: InputMaybe<Scalars['String']['input']>;
  KG_STATUS_DONE?: InputMaybe<Scalars['String']['input']>;
  KG_STATUS_FAILED?: InputMaybe<Scalars['String']['input']>;
  KG_STATUS_PENDING?: InputMaybe<Scalars['String']['input']>;
  confidence?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  kgExtractedAt?: InputMaybe<Scalars['Long']['input']>;
  kgExtractionStatus?: InputMaybe<Scalars['String']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceDate?: InputMaybe<Scalars['Long']['input']>;
  sourceRef?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a CompanyKnowledgeList query */
export type CompanyKnowledgeListResult = {
  __typename?: 'CompanyKnowledgeListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<CompanyKnowledge>>>;
  /** Total number of CompanyKnowledge records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Paginated result of a CompanyList query */
export type CompanyListResult = {
  __typename?: 'CompanyListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Company>>>;
  /** Total number of Company records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ConnectionAuthStart = {
  __typename?: 'ConnectionAuthStart';
  authorizationUrl: Scalars['String']['output'];
  connectionId: Scalars['ID']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
};

export type Connector = {
  __typename?: 'Connector';
  feeds?: Maybe<Array<ConnectorFeed>>;
  sourceType: Scalars['String']['output'];
};

export type ConnectorFeed = {
  __typename?: 'ConnectorFeed';
  name: Scalars['String']['output'];
  schema?: Maybe<Array<ConnectorField>>;
};

export type ConnectorField = {
  __typename?: 'ConnectorField';
  field: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type CreateIntegrationInput = {
  connection: Scalars['ID']['input'];
  connector: Scalars['String']['input'];
  feed: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  mapping?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  precedence?: InputMaybe<Scalars['Int']['input']>;
  target: Scalars['String']['input'];
};

/** Paginated result of a dashboards query */
export type DashboardListResult = {
  __typename?: 'DashboardListResult';
  /** Whether more dashboards exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  /** Dashboards on this page */
  items?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Total dashboards matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum DashboardType {
  Custom = 'CUSTOM',
  Standard = 'STANDARD'
}

/** Department entity representing an organizational unit */
export type Department = BaseEntity & {
  __typename?: 'Department';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isMGSAEnabled?: Maybe<Scalars['Boolean']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type DepartmentInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isMGSAEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Reified, provenance-bearing relationship between two Org Knowledge Graph nodes */
export type Edge = BaseEntity & {
  __typename?: 'Edge';
  MILLIS_PER_DAY?: Maybe<Scalars['Long']['output']>;
  OBSERVED_DAYS_RETENTION?: Maybe<Scalars['Int']['output']>;
  attributes?: Maybe<Scalars['JSON']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  evidenceRefs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  objectId?: Maybe<BaseEntity>;
  objectType?: Maybe<Scalars['String']['output']>;
  observedAt?: Maybe<Scalars['Long']['output']>;
  observedDays?: Maybe<Array<Maybe<Scalars['Long']['output']>>>;
  predicate?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  subjectId?: Maybe<BaseEntity>;
  subjectType?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['Long']['output']>;
  validTo?: Maybe<Scalars['Long']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type EdgeInput = {
  MILLIS_PER_DAY?: InputMaybe<Scalars['Long']['input']>;
  OBSERVED_DAYS_RETENTION?: InputMaybe<Scalars['Int']['input']>;
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  confidence?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  evidenceRefs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  objectId?: InputMaybe<Scalars['ID']['input']>;
  objectType?: InputMaybe<Scalars['String']['input']>;
  observedAt?: InputMaybe<Scalars['Long']['input']>;
  observedDays?: InputMaybe<Array<InputMaybe<Scalars['Long']['input']>>>;
  predicate?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  subjectId?: InputMaybe<Scalars['ID']['input']>;
  subjectType?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['Long']['input']>;
  validTo?: InputMaybe<Scalars['Long']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

/** Paginated result of a EdgeList query */
export type EdgeListResult = {
  __typename?: 'EdgeListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Edge>>>;
  /** Total number of Edge records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Lookup sequence for auto-generated entity codes (prefix + nextCode + padding) */
export type EntityCodeLookup = BaseEntity & {
  __typename?: 'EntityCodeLookup';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  nextCode?: Maybe<Scalars['Int']['output']>;
  padding?: Maybe<Scalars['Int']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  sourceEntityType?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

/** Peeked entity-code sequence for one sourceEntityType */
export type EntityCodeLookupItem = {
  __typename?: 'EntityCodeLookupItem';
  /** Formatted next code — FE should send this as entityId on create */
  code?: Maybe<Scalars['String']['output']>;
  nextCode?: Maybe<Scalars['Int']['output']>;
  padding?: Maybe<Scalars['Int']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  sourceEntityType?: Maybe<Scalars['String']['output']>;
};

export type EntityCodeLookupListResult = {
  __typename?: 'EntityCodeLookupListResult';
  items: Array<EntityCodeLookupItem>;
};

export type EntityExportStatus = {
  __typename?: 'EntityExportStatus';
  error?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<Maybe<ExportedFile>>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type EntityExportTrigger = {
  __typename?: 'EntityExportTrigger';
  triggerId: Scalars['ID']['output'];
};

export type ExportJobHistory = BaseEntity & {
  __typename?: 'ExportJobHistory';
  completedAt?: Maybe<Scalars['Long']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  durationMs?: Maybe<Scalars['Long']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  exportJobId?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  reportDefinitionId?: Maybe<Scalars['String']['output']>;
  rowCount?: Maybe<Scalars['Int']['output']>;
  sourceEntityId?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['Long']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type ExportJobHistoryInput = {
  completedAt?: InputMaybe<Scalars['Long']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  durationMs?: InputMaybe<Scalars['Long']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  exportJobId?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  reportDefinitionId?: InputMaybe<Scalars['String']['input']>;
  rowCount?: InputMaybe<Scalars['Int']['input']>;
  sourceEntityId?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['Long']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a ExportJobHistoryList query */
export type ExportJobHistoryListResult = {
  __typename?: 'ExportJobHistoryListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<ExportJobHistory>>>;
  /** Total number of ExportJobHistory records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ExportedFile = {
  __typename?: 'ExportedFile';
  downloadUrl: Scalars['String']['output'];
  expiresAt: Scalars['Long']['output'];
  fileId: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type FieldChange = {
  __typename?: 'FieldChange';
  displayName?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  newValue?: Maybe<Scalars['JSON']['output']>;
  oldValue?: Maybe<Scalars['JSON']['output']>;
};

export type File = {
  __typename?: 'File';
  contentType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Long']['output']>;
  uploadDate?: Maybe<Scalars['Long']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FileDownloadInfo = {
  __typename?: 'FileDownloadInfo';
  expiresAt?: Maybe<Scalars['Long']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  mode: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type FileInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Long']['input']>;
  uploadDate?: InputMaybe<Scalars['Long']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** A platform-defined functional permission assigned via FunctionalPermissionGrant */
export type FunctionalPermission = {
  __typename?: 'FunctionalPermission';
  description?: Maybe<Scalars['String']['output']>;
  /** Stable key stored on FunctionalPermissionGrant.functionalPermission */
  key: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** Product area this permission belongs to, for grouping the catalogue. Null keys fall into an 'Other' group. */
  module?: Maybe<Scalars['String']['output']>;
  /** TypePermission grants this key implies. Empty for keys with no entity-type ACL. */
  typeScopes: Array<FunctionalPermissionTypeScope>;
};

/** Stable keys of platform-defined functional permissions (see the FunctionalPermission catalog) */
export enum FunctionalPermissionKey {
  /** Create Course */
  CourseCreate = 'COURSE_CREATE',
  /** Publish Course */
  CoursePublish = 'COURSE_PUBLISH',
  /** Create Custom Agent */
  CreateCustomAgent = 'CREATE_CUSTOM_AGENT',
  /** Create Custom Workflow */
  CreateCustomWorkflow = 'CREATE_CUSTOM_WORKFLOW',
  /** Manage Academy */
  ManageAcademy = 'MANAGE_ACADEMY',
  /** Manage Action Plan */
  ManageActionPlan = 'MANAGE_ACTION_PLAN',
  /** Manage Announcement */
  ManageAnnouncement = 'MANAGE_ANNOUNCEMENT',
  /** Manage Assignments */
  ManageAssignments = 'MANAGE_ASSIGNMENTS',
  /** Manage Authentication */
  ManageAuth = 'MANAGE_AUTH',
  /** Manage Community */
  ManageCommunity = 'MANAGE_COMMUNITY',
  /** Manage Configuration */
  ManageConfig = 'MANAGE_CONFIG',
  /** Manage Content */
  ManageContent = 'MANAGE_CONTENT',
  /** Manage Department */
  ManageDepartment = 'MANAGE_DEPARTMENT',
  /** Manage Employee Relations */
  ManageEmployeeRelations = 'MANAGE_EMPLOYEE_RELATIONS',
  /** Manage Event */
  ManageEvent = 'MANAGE_EVENT',
  /** Manage Feedback */
  ManageFeedback = 'MANAGE_FEEDBACK',
  /** Manage Gamification */
  ManageGamification = 'MANAGE_GAMIFICATION',
  /** Manage Habit */
  ManageHabit = 'MANAGE_HABIT',
  /** Manage Homepage */
  ManageHomepage = 'MANAGE_HOMEPAGE',
  /** Manage Integrations */
  ManageIntegrations = 'MANAGE_INTEGRATIONS',
  /** Invite Users */
  ManageInviteUser = 'MANAGE_INVITE_USER',
  /** Manage Job Profile */
  ManageJobProfile = 'MANAGE_JOB_PROFILE',
  /** Manage Journey */
  ManageJourney = 'MANAGE_JOURNEY',
  /** Manage Lyearn Connect */
  ManageLyearnConnect = 'MANAGE_LYEARN_CONNECT',
  /** Masquerade as User */
  ManageMasquerade = 'MANAGE_MASQUERADE',
  /** Manage Meeting */
  ManageMeeting = 'MANAGE_MEETING',
  /** Merge Accounts */
  ManageMergeAccount = 'MANAGE_MERGE_ACCOUNT',
  /** Manage Notifications */
  ManageNotifications = 'MANAGE_NOTIFICATIONS',
  /** Manage OKR */
  ManageOkr = 'MANAGE_OKR',
  /** Manage Onboarding */
  ManageOnboarding = 'MANAGE_ONBOARDING',
  /** Manage 1:1 */
  ManageOneOnOne = 'MANAGE_ONE_ON_ONE',
  /** Manage Org Chart */
  ManageOrgChart = 'MANAGE_ORG_CHART',
  /** Manage People Compliance */
  ManagePeopleCompliance = 'MANAGE_PEOPLE_COMPLIANCE',
  /** Manage Permissions */
  ManagePermissions = 'MANAGE_PERMISSIONS',
  /** Manage Position */
  ManagePosition = 'MANAGE_POSITION',
  /** Manage Praise */
  ManagePraise = 'MANAGE_PRAISE',
  /** Manage Productivity Models */
  ManageProductivityModel = 'MANAGE_PRODUCTIVITY_MODEL',
  /** Manage Report */
  ManageReport = 'MANAGE_REPORT',
  /** Manage Review */
  ManageReview = 'MANAGE_REVIEW',
  /** Manage Roles */
  ManageRoles = 'MANAGE_ROLES',
  /** Manage Routine */
  ManageRoutine = 'MANAGE_ROUTINE',
  /** Manage Scorecards */
  ManageScorecards = 'MANAGE_SCORECARDS',
  /** Manage Session */
  ManageSession = 'MANAGE_SESSION',
  /** Manage Subaccounts */
  ManageSubaccounts = 'MANAGE_SUBACCOUNTS',
  /** Manage Subscription */
  ManageSubscription = 'MANAGE_SUBSCRIPTION',
  /** Manage Survey */
  ManageSurvey = 'MANAGE_SURVEY',
  /** Manage Tags */
  ManageTags = 'MANAGE_TAGS',
  /** Manage Task */
  ManageTask = 'MANAGE_TASK',
  /** Manage Users */
  ManageUsers = 'MANAGE_USERS',
  /** Manage User Groups */
  ManageUserGroups = 'MANAGE_USER_GROUPS',
  /** Manage Workspaces */
  ManageWorkspaces = 'MANAGE_WORKSPACES',
  /** Run Payroll */
  RunPayroll = 'RUN_PAYROLL',
  /** Use Agent Chat */
  UseAgentChat = 'USE_AGENT_CHAT',
  /** Use Agent Draft */
  UseAgentDraft = 'USE_AGENT_DRAFT',
  /** Use Custom Agent */
  UseCustomAgent = 'USE_CUSTOM_AGENT',
  /** Use Custom Workflow */
  UseCustomWorkflow = 'USE_CUSTOM_WORKFLOW',
  /** Use OKR */
  UseOkr = 'USE_OKR',
  /** Use Report */
  UseReport = 'USE_REPORT',
  /** Use System Agent */
  UseSystemAgent = 'USE_SYSTEM_AGENT',
  /** View Action Plan */
  ViewActionPlan = 'VIEW_ACTION_PLAN',
  /** View Everyone's Productivity Scores */
  ViewAllProductivityScores = 'VIEW_ALL_PRODUCTIVITY_SCORES',
  /** View Analytics V1 */
  ViewAnalyticsV1 = 'VIEW_ANALYTICS_V1',
  /** View Announcement */
  ViewAnnouncement = 'VIEW_ANNOUNCEMENT',
  /** View Audit Log */
  ViewAuditLog = 'VIEW_AUDIT_LOG',
  /** View Bookmarks */
  ViewBookmarks = 'VIEW_BOOKMARKS',
  /** View Community */
  ViewCommunity = 'VIEW_COMMUNITY',
  /** View Content */
  ViewContent = 'VIEW_CONTENT',
  /** View Event */
  ViewEvent = 'VIEW_EVENT',
  /** View Feedback */
  ViewFeedback = 'VIEW_FEEDBACK',
  /** View Gamification */
  ViewGamification = 'VIEW_GAMIFICATION',
  /** View Habit */
  ViewHabit = 'VIEW_HABIT',
  /** View Integrations */
  ViewIntegrations = 'VIEW_INTEGRATIONS',
  /** View Job Profile */
  ViewJobProfile = 'VIEW_JOB_PROFILE',
  /** View Journey */
  ViewJourney = 'VIEW_JOURNEY',
  /** View Meeting */
  ViewMeeting = 'VIEW_MEETING',
  /** View 1:1 */
  ViewOneOnOne = 'VIEW_ONE_ON_ONE',
  /** View Org Chart */
  ViewOrgChart = 'VIEW_ORG_CHART',
  /** View Praise */
  ViewPraise = 'VIEW_PRAISE',
  /** View Review */
  ViewReview = 'VIEW_REVIEW',
  /** View Salary */
  ViewSalary = 'VIEW_SALARY',
  /** View Session */
  ViewSession = 'VIEW_SESSION',
  /** View Skill */
  ViewSkill = 'VIEW_SKILL',
  /** View Survey */
  ViewSurvey = 'VIEW_SURVEY',
  /** View Task */
  ViewTask = 'VIEW_TASK',
  /** View Team Productivity Scores */
  ViewTeamProductivityScores = 'VIEW_TEAM_PRODUCTIVITY_SCORES'
}

/** A TypePermission grant implied by a functional permission key */
export type FunctionalPermissionTypeScope = {
  __typename?: 'FunctionalPermissionTypeScope';
  actions?: Maybe<Array<Scalars['String']['output']>>;
  resourceType: Scalars['String']['output'];
};

export type Functional_Permission_Grant = BaseEntity & {
  __typename?: 'Functional_Permission_Grant';
  actor?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  functionalPermission?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

/** Paginated result of a Functional_Permission_GrantList query */
export type Functional_Permission_GrantListResult = {
  __typename?: 'Functional_Permission_GrantListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Functional_Permission_Grant>>>;
  /** Total number of Functional_Permission_Grant records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GeoLocation = {
  __typename?: 'GeoLocation';
  coordinates?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GeoLocationInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type Global_Permission = BaseEntity & {
  __typename?: 'Global_Permission';
  access?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

/** Global goal registry entry */
export type Goal = BaseEntity & {
  __typename?: 'Goal';
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type GoalInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a GoalList query */
export type GoalListResult = {
  __typename?: 'GoalListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Goal>>>;
  /** Total number of Goal records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Group_Membership = BaseEntity & {
  __typename?: 'Group_Membership';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  dynamicGroupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  groupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  person?: Maybe<Person>;
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  staticGroupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subjectId?: Maybe<Scalars['String']['output']>;
  subjectType?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  userGroup?: Maybe<UserGroup>;
  version?: Maybe<Scalars['Long']['output']>;
};

/** Paginated result of a Group_MembershipList query */
export type Group_MembershipListResult = {
  __typename?: 'Group_MembershipListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Group_Membership>>>;
  /** Total number of Group_Membership records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Link from an external-system identity to a canonical Person */
export type IdentityLink = BaseEntity & {
  __typename?: 'IdentityLink';
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  externalUserId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  personId?: Maybe<Person>;
  source?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['Long']['output']>;
  validTo?: Maybe<Scalars['Long']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type IdentityLinkInput = {
  confidence?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  externalUserId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['Long']['input']>;
  validTo?: InputMaybe<Scalars['Long']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a IdentityLinkList query */
export type IdentityLinkListResult = {
  __typename?: 'IdentityLinkListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<IdentityLink>>>;
  /** Total number of IdentityLink records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ImportJob = {
  __typename?: 'ImportJob';
  triggerId: Scalars['ID']['output'];
};

export type ImportValidationResult = {
  __typename?: 'ImportValidationResult';
  errors?: Maybe<Array<Maybe<CellError>>>;
  rowActions?: Maybe<Scalars['JSON']['output']>;
};

export type InitBrowserUploadInput = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  purposeEntityId?: InputMaybe<Scalars['ID']['input']>;
  purposeType?: InputMaybe<Scalars['String']['input']>;
};

/** AI-generated insight for an entity */
export type Insight = BaseEntity & {
  __typename?: 'Insight';
  agentCode?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  evidence?: Maybe<Scalars['String']['output']>;
  expiryTime?: Maybe<Scalars['Long']['output']>;
  id: Scalars['ID']['output'];
  insightCategory?: Maybe<Scalars['String']['output']>;
  insightId?: Maybe<Scalars['String']['output']>;
  insightType?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  payload?: Maybe<Scalars['JSON']['output']>;
  personId?: Maybe<Person>;
  processName?: Maybe<Scalars['String']['output']>;
  productivityModel?: Maybe<Scalars['String']['output']>;
  sourceEntityId?: Maybe<Scalars['String']['output']>;
  sourceEntityType?: Maybe<Scalars['String']['output']>;
  subjectRefs?: Maybe<Array<Maybe<BaseEntity>>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

/** Per-person suppression of an insight */
export type InsightSuppression = BaseEntity & {
  __typename?: 'InsightSuppression';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insightId?: Maybe<Insight>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  personId?: Maybe<Person>;
  suppressed?: Maybe<Scalars['Boolean']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type Integration = BaseEntity & {
  __typename?: 'Integration';
  connection?: Maybe<IntegrationConnection>;
  connector?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  cursor?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  feed?: Maybe<Scalars['String']['output']>;
  healthy?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  kind?: Maybe<Scalars['String']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  lastSyncAt?: Maybe<Scalars['Long']['output']>;
  lastSyncStatus?: Maybe<Scalars['String']['output']>;
  mapping?: Maybe<Scalars['JSON']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  nextSyncAt?: Maybe<Scalars['Long']['output']>;
  precedence?: Maybe<Scalars['Int']['output']>;
  syncFrequency?: Maybe<Scalars['Long']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type IntegrationConnection = BaseEntity & {
  __typename?: 'IntegrationConnection';
  connectionId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  gateway?: Maybe<Scalars['String']['output']>;
  healthy?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  providerConfigKey?: Maybe<Scalars['String']['output']>;
  sourceType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type IntegrationConnectionSummary = {
  __typename?: 'IntegrationConnectionSummary';
  healthy?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  sourceType: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type IntegrationInput = {
  connection?: InputMaybe<Scalars['ID']['input']>;
  connector?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  feed?: InputMaybe<Scalars['String']['input']>;
  healthy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  lastError?: InputMaybe<Scalars['String']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  lastSyncAt?: InputMaybe<Scalars['Long']['input']>;
  lastSyncStatus?: InputMaybe<Scalars['String']['input']>;
  mapping?: InputMaybe<Scalars['JSON']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  nextSyncAt?: InputMaybe<Scalars['Long']['input']>;
  precedence?: InputMaybe<Scalars['Int']['input']>;
  syncFrequency?: InputMaybe<Scalars['Long']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Interaction entity derived from Activity */
export type Interaction = BaseEntity & {
  __typename?: 'Interaction';
  activityId?: Maybe<Activity>;
  actorPersonId?: Maybe<Person>;
  commsQuality?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  direction?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  model?: Maybe<Scalars['String']['output']>;
  participantPersonIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  responseTimeSecs?: Maybe<Scalars['Long']['output']>;
  signalType?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['Long']['output']>;
  subjectIds?: Maybe<Array<Maybe<BaseEntity>>>;
  summary?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type InteractionInput = {
  activityId?: InputMaybe<Scalars['ID']['input']>;
  actorPersonId?: InputMaybe<Scalars['ID']['input']>;
  commsQuality?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  participantPersonIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  responseTimeSecs?: InputMaybe<Scalars['Long']['input']>;
  signalType?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['Long']['input']>;
  subjectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  summary?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  threadId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a InteractionList query */
export type InteractionListResult = {
  __typename?: 'InteractionListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Interaction>>>;
  /** Total number of Interaction records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Grouping of related job profiles within a job family group */
export type JobFamily = BaseEntity & {
  __typename?: 'JobFamily';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobFamilyGroup?: Maybe<JobFamilyGroup>;
  /** Number of job profiles belonging to this job family */
  jobProfileCount?: Maybe<Scalars['Int']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

/** Top-level grouping of job families */
export type JobFamilyGroup = BaseEntity & {
  __typename?: 'JobFamilyGroup';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Number of job families belonging to this group */
  jobFamilyCount?: Maybe<Scalars['Int']['output']>;
  /** Number of job profiles belonging to this group */
  jobProfileCount?: Maybe<Scalars['Int']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type JobFamilyGroupInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a JobFamilyGroupList query */
export type JobFamilyGroupListResult = {
  __typename?: 'JobFamilyGroupListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<JobFamilyGroup>>>;
  /** Total number of JobFamilyGroup records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type JobFamilyInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobFamilyGroup?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a JobFamilyList query */
export type JobFamilyListResult = {
  __typename?: 'JobFamilyListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<JobFamily>>>;
  /** Total number of JobFamily records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Generic role definition used for recruitment, compensation, and OKR generation */
export type JobProfile = BaseEntity & {
  __typename?: 'JobProfile';
  careerLevelId?: Maybe<CareerLevel>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isManager?: Maybe<Scalars['Boolean']['output']>;
  jobFamily?: Maybe<JobFamily>;
  jobGrade?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  managementScope?: Maybe<Scalars['String']['output']>;
  minYearsExperience?: Maybe<Scalars['Int']['output']>;
  preferredQualifications?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  preferredSkills?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  requiredQualifications?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  requiredSkills?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  responsibilities?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
  workingConditions?: Maybe<Scalars['JSON']['output']>;
};

export type JobProfileInput = {
  careerLevelId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  jobFamily?: InputMaybe<Scalars['ID']['input']>;
  jobGrade?: InputMaybe<Scalars['String']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  managementScope?: InputMaybe<Scalars['String']['input']>;
  minYearsExperience?: InputMaybe<Scalars['Int']['input']>;
  preferredQualifications?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  preferredSkills?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  requiredQualifications?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  requiredSkills?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  responsibilities?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
  workingConditions?: InputMaybe<Scalars['JSON']['input']>;
};

/** Paginated result of a JobProfileList query */
export type JobProfileListResult = {
  __typename?: 'JobProfileListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<JobProfile>>>;
  /** Total number of JobProfile records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A measurable outcome that defines how progress against an Objective is evaluated — tracks baseline, target, and current value across check-ins */
export type KeyResult = BaseEntity & {
  __typename?: 'KeyResult';
  /** User assigned via ASSIGN_KEYRESULT, including grant template/actions and person details — null when no user assignee grant exists */
  assignee?: Maybe<Scalars['JSON']['output']>;
  baselineValue?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  currency?: Maybe<Scalars['String']['output']>;
  currentValue?: Maybe<Scalars['Float']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['Long']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  objectiveId?: Maybe<Objective>;
  ownerPositionId?: Maybe<Position>;
  progress?: Maybe<Scalars['Float']['output']>;
  sourceRef?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  targetValue?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

/** Generic instance of any ontology-pack knowledge node kind */
export type KnowledgeNode = BaseEntity & {
  __typename?: 'KnowledgeNode';
  aliases?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  attributes?: Maybe<Scalars['JSON']['output']>;
  canonicalName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  nodeKind?: Maybe<Scalars['String']['output']>;
  normalizedName?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type KnowledgeNodeInput = {
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attributes?: InputMaybe<Scalars['JSON']['input']>;
  canonicalName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  nodeKind?: InputMaybe<Scalars['String']['input']>;
  normalizedName?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a KnowledgeNodeList query */
export type KnowledgeNodeListResult = {
  __typename?: 'KnowledgeNodeListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<KnowledgeNode>>>;
  /** Total number of KnowledgeNode records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Physical workplace location that positions can be assigned to */
export type Location = BaseEntity & {
  __typename?: 'Location';
  address?: Maybe<Address>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  geoLocation?: Maybe<GeoLocation>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  locationType?: Maybe<Scalars['String']['output']>;
  parentLocationId?: Maybe<Location>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type LocationInput = {
  address?: InputMaybe<AddressInput>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  geoLocation?: InputMaybe<GeoLocationInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  locationType?: InputMaybe<Scalars['String']['input']>;
  parentLocationId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a LocationList query */
export type LocationListResult = {
  __typename?: 'LocationListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Location>>>;
  /** Total number of Location records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Global metric definition (stored in global_data) */
export type Metric = BaseEntity & {
  __typename?: 'Metric';
  aggregation?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  dataSources?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  defaultAnchorHi?: Maybe<Scalars['Float']['output']>;
  defaultAnchorLo?: Maybe<Scalars['Float']['output']>;
  defaultDirection?: Maybe<Scalars['String']['output']>;
  defaultIdealValue?: Maybe<Scalars['Float']['output']>;
  defaultMaxDeviation?: Maybe<Scalars['Float']['output']>;
  defaultNormType?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  dependsOn?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  formula?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  metricType?: Maybe<Scalars['String']['output']>;
  minimumData?: Maybe<Scalars['String']['output']>;
  minimumDataThreshold?: Maybe<Scalars['Int']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
  windowType?: Maybe<Scalars['String']['output']>;
};

export type MetricInput = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  dataSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  defaultAnchorHi?: InputMaybe<Scalars['Float']['input']>;
  defaultAnchorLo?: InputMaybe<Scalars['Float']['input']>;
  defaultDirection?: InputMaybe<Scalars['String']['input']>;
  defaultIdealValue?: InputMaybe<Scalars['Float']['input']>;
  defaultMaxDeviation?: InputMaybe<Scalars['Float']['input']>;
  defaultNormType?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  dependsOn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  formula?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  metricType?: InputMaybe<Scalars['String']['input']>;
  minimumData?: InputMaybe<Scalars['String']['input']>;
  minimumDataThreshold?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
  windowType?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a MetricList query */
export type MetricListResult = {
  __typename?: 'MetricListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Metric>>>;
  /** Total number of Metric records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Every metric computed for one subject in one window */
export type MetricScore = BaseEntity & {
  __typename?: 'MetricScore';
  SEP?: Maybe<Scalars['String']['output']>;
  computedAt?: Maybe<Scalars['Long']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  metrics?: Maybe<Scalars['JSON']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  rollsUpTo?: Maybe<BaseEntity>;
  subjectId?: Maybe<BaseEntity>;
  subjectType?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
  windowEnd?: Maybe<Scalars['Long']['output']>;
};

/** Global mindset registry entry */
export type Mindset = BaseEntity & {
  __typename?: 'Mindset';
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type MindsetInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a MindsetList query */
export type MindsetListResult = {
  __typename?: 'MindsetListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Mindset>>>;
  /** Total number of Mindset records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Money = {
  __typename?: 'Money';
  amount?: Maybe<Scalars['Long']['output']>;
  baseAmount?: Maybe<Scalars['Long']['output']>;
  baseCurrency?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
};

export type MoneyInput = {
  amount?: InputMaybe<Scalars['Long']['input']>;
  baseAmount?: InputMaybe<Scalars['Long']['input']>;
  baseCurrency?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Create a check-in on a key result — denormalizes previousValue and triggers progress rollup */
  addCheckIn?: Maybe<Scalars['JSON']['output']>;
  /** Create a comment on any entity — optional attachments (ACL-enforced) */
  addComment?: Maybe<Scalars['JSON']['output']>;
  /** Create a department (ACL-enforced) */
  addDepartment: Department;
  /** Create an initiative (ACL-enforced) */
  addInitiative?: Maybe<Scalars['JSON']['output']>;
  /** Create a job family (ACL-enforced) */
  addJobFamily: JobFamily;
  /** Create a job family group (ACL-enforced) */
  addJobFamilyGroup: JobFamilyGroup;
  /** Create a job profile (ACL-enforced) */
  addJobProfile: JobProfile;
  /** Add a key result under an objective — no downstream invalidation */
  addKeyResult?: Maybe<Scalars['JSON']['output']>;
  /** Create a location. Requires MANAGE_ORG_CHART. */
  addLocation: Location;
  /** Add an objective to the OKR; for COMPANY level, eagerly invalidates cascade downstream unless isManual is true */
  addObjective?: Maybe<Scalars['JSON']['output']>;
  /** Add an org to a COMPANY objective's cascadeOrgIds and eagerly invalidate cascade downstream */
  addOrgAssignment?: Maybe<Scalars['Boolean']['output']>;
  /** Appends change items to a draft. Each item needs op, targetId, and changes (keyed by the op's field, e.g. {"parentOrgId": "..."}); optional rationale and state (SUGGESTED default, or ACCEPTED). The service captures each item's expected base from live state, merges items hitting an entity+field already in the draft, and drops values that are already live — the counts report exactly what happened. Requires MANAGE_ORG_CHART. */
  addOrgChangeItems: AddOrgChangeItemsResult;
  /** Invite a person and create their Person record. Requires MANAGE_ORG_CHART. */
  addPerson: Person;
  /** Create a position through the given draft: nothing is created yet — a CREATE_POSITION item lands in the draft and the returned position is transient (final id, null orgPath until the draft publishes) */
  addPosition: Position;
  /** Attach a strategy document to an OKR — Phase 2 */
  addStrategyInput?: Maybe<Scalars['JSON']['output']>;
  /** Add a theme to the OKR and eagerly invalidate downstream */
  addTheme?: Maybe<Scalars['JSON']['output']>;
  /** Create a user task (ACL-enforced) */
  addUserTask?: Maybe<Scalars['JSON']['output']>;
  /** Archive an entity — for Objective, recursively archives child objectives and key results; for OKRCycle, recursively archives descendant cycles (e.g. an annual cycle's quarterly children) */
  archiveEntity?: Maybe<Scalars['Boolean']['output']>;
  assignGroups?: Maybe<Scalars['Boolean']['output']>;
  /** Enrols everyone holding a job profile, replacing whatever role that profile carried. A person enrolled in their own right keeps their own role — the individual assignment wins. Same validation as assignProductivityRoleToUser. Requires MANAGE_PRODUCTIVITY_MODEL. */
  assignProductivityRoleToJobProfile: AssignedActor;
  /** Enrols one person in a model, replacing whatever role they held. An actor performs exactly one role in one model, so enrolling someone already on another model moves them rather than adding to it. Errors when the model is not enabled or the role is not one it declares — read the valid names from productivityModelDefinition(name:) { roles }. Requires MANAGE_PRODUCTIVITY_MODEL. */
  assignProductivityRoleToUser: AssignedActor;
  assignRoles?: Maybe<Scalars['Boolean']['output']>;
  clearFunctionalPermissions?: Maybe<Scalars['Boolean']['output']>;
  commitImport: ImportJob;
  /** Complete the auth flow after the user returns: the backend fetches the created connection from the provider and activates it. */
  completeConnectionAuth?: Maybe<IntegrationConnectionSummary>;
  /** Confirm that a browser upload completed. Transitions the pending file to AVAILABLE and records its size. */
  confirmBrowserUpload?: Maybe<StoredFile>;
  /** Confirm human-reviewed extraction result — Phase 2 */
  confirmExtraction?: Maybe<Scalars['Boolean']['output']>;
  /** Confirm company knowledge base is healthy — Phase 1; advances OKR from PENDING to KNOWLEDGE_CONFIRMED */
  confirmKnowledgeHealth?: Maybe<Scalars['Boolean']['output']>;
  /** Confirm objective-to-org assignments and grant OKR_VIEWER to assigned orgs — Phase 7 */
  confirmOrgAssignments?: Maybe<Scalars['Boolean']['output']>;
  /** Confirm the leader's answers to the strategy questions — Phase 2; packages the Q&A transcript into a synthetic STRATEGY_QA strategy input and runs it through the ordinary extraction pipeline, returning the created StrategyInput */
  confirmStrategyQuestions?: Maybe<Scalars['JSON']['output']>;
  /** Confirm the leader's answers to clarifying questions (may be empty) — Phase 4; advances to QUESTIONS_CONFIRMED */
  confirmThemeAnswers?: Maybe<Scalars['Boolean']['output']>;
  /** Confirm human-edited theme list — Phase 3 */
  confirmThemes?: Maybe<Scalars['Boolean']['output']>;
  /** Confirm human-reviewed top objectives — Phase 6; advances to TOP_CONFIRMED */
  confirmTopObjectives?: Maybe<Scalars['Boolean']['output']>;
  /** Create and schedule an async export job */
  createExportJob?: Maybe<Scalars['JSON']['output']>;
  /** Create a binding: one connector feed -> one target, through a connection. */
  createIntegration?: Maybe<Integration>;
  /** Create an OKR planning period for the tenant (cadence-aware; at most 3 upcoming root periods). Optional year/quarter target a fiscal period using Company.fiscalYearStartMonth; omit both to auto-advance. */
  createOKRCycle?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Create OKR shell(s) with cadence validation — auto-creates quarterly child shells for ORG OKRs on annual cycles with QUARTERLY_WITH_ANNUAL cadence; rejects direct quarterly ORG OKR creation under that cadence */
  createOKRShells?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Create an org through the given draft: nothing is created yet — a CREATE_ORG item lands in the draft and the returned org is transient (final id, null path/depth until the draft publishes). Root orgs omit parentOrgId. Requires MANAGE_ORG_CHART. */
  createOrg: Org;
  /** Branches a new, empty ADMIN change set from the current published truth. Multiple admin drafts may be open concurrently. Requires MANAGE_ORG_CHART. */
  createOrgChangeSet: OrgChangeSet;
  createRole?: Maybe<App_Role>;
  createUserGroup?: Maybe<UserGroup>;
  /** Soft-deletes the chat. Requires DELETE on the session (USE_AGENT_CHAT — owner or share); it disappears from myAgentChats. Refused while the agent is executing. */
  deleteAgentChat: Scalars['Boolean']['output'];
  /** Permanently delete an AnalyticsView by ID */
  deleteAnalyticsView?: Maybe<Scalars['Boolean']['output']>;
  /** Soft-delete a check-in and trigger progress rollup */
  deleteCheckIn?: Maybe<Scalars['Boolean']['output']>;
  /** Soft-delete a comment (ACL-enforced) */
  deleteComment?: Maybe<Scalars['Boolean']['output']>;
  /** Permanently delete a Dashboard by ID */
  deleteDashboard?: Maybe<Scalars['Boolean']['output']>;
  /** Soft-delete a department (ACL-enforced) */
  deleteDepartment?: Maybe<Scalars['Boolean']['output']>;
  /** Soft-delete an initiative (ACL-enforced) */
  deleteInitiative?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a binding by id. */
  deleteIntegration?: Maybe<Scalars['Boolean']['output']>;
  /** Soft-delete a job family (ACL-enforced) */
  deleteJobFamily?: Maybe<Scalars['Boolean']['output']>;
  /** Soft-delete a job family group (ACL-enforced) */
  deleteJobFamilyGroup?: Maybe<Scalars['Boolean']['output']>;
  /** Soft-delete a job profile (ACL-enforced) */
  deleteJobProfile?: Maybe<Scalars['Boolean']['output']>;
  /** Soft-delete a key result — no downstream invalidation */
  deleteKeyResult?: Maybe<Scalars['Boolean']['output']>;
  /** Soft-delete a location. Fails when positions still reference it. Requires MANAGE_ORG_CHART. */
  deleteLocation?: Maybe<Scalars['Boolean']['output']>;
  /** Soft-delete an objective and its descendants; for COMPANY level, eagerly invalidates cascade downstream unless isManual is true */
  deleteObjective?: Maybe<Scalars['Boolean']['output']>;
  /** Delete an org through the given draft: an ARCHIVE_ORG item lands in the draft — delete is archive, the org stays live until publish, and publish conflicts while it has active child orgs or positions. Requires MANAGE_ORG_CHART. */
  deleteOrg?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a position through the given draft: an ARCHIVE_POSITION item lands in the draft — delete is archive; the seat stays live until the draft publishes */
  deletePosition?: Maybe<Scalars['Boolean']['output']>;
  deleteRole?: Maybe<Scalars['Boolean']['output']>;
  /** Removes one of the caller's own routines by routineId (document id or bare entity id). MANAGE_ROUTINE required. */
  deleteRoutine: Scalars['Boolean']['output'];
  /** Delete a file from cloud storage and soft-delete the StoredFile entity. */
  deleteStoredFile?: Maybe<Scalars['Boolean']['output']>;
  /** Soft-delete a strategy input and eagerly invalidate all downstream artifacts */
  deleteStrategyInput?: Maybe<Scalars['Boolean']['output']>;
  /** Soft-deletes an authored agent. Sessions bound to its code stop resolving. USE_CUSTOM_AGENT required. */
  deleteTenantAgent: Scalars['Boolean']['output'];
  /** Soft-deletes the caller's authored workflow. It leaves their library at once, and its routines are removed with it. USE_CUSTOM_WORKFLOW required. */
  deleteTenantWorkflow: Scalars['Boolean']['output'];
  /** Delete a theme from the OKR and eagerly invalidate downstream */
  deleteTheme?: Maybe<Scalars['Boolean']['output']>;
  deleteUserGroup?: Maybe<Scalars['Boolean']['output']>;
  /** Soft-delete a user task (ACL-enforced) */
  deleteUserTask?: Maybe<Scalars['Boolean']['output']>;
  /** Discards an admin draft without applying anything. Standing AGENT/SYNC lanes are cleared and re-based instead of discarded. Requires MANAGE_ORG_CHART. */
  discardOrgChangeSet?: Maybe<Scalars['Boolean']['output']>;
  /** Edit a check-in — triggers progress rollup when newValue changes */
  editCheckIn?: Maybe<Scalars['JSON']['output']>;
  /** Edit a clarifying question's answer and eagerly invalidate downstream */
  editClarificationAnswer?: Maybe<Scalars['Boolean']['output']>;
  /** Edit a comment — body, mentions, attachments, status, or resolve state (ACL-enforced) */
  editComment?: Maybe<Scalars['JSON']['output']>;
  /** Edit a department (ACL-enforced) */
  editDepartment: Department;
  /** Edit an initiative (ACL-enforced) */
  editInitiative?: Maybe<Scalars['JSON']['output']>;
  /** Edit a job family (ACL-enforced) */
  editJobFamily: JobFamily;
  /** Edit a job family group (ACL-enforced) */
  editJobFamilyGroup: JobFamilyGroup;
  /** Edit a job profile (ACL-enforced) */
  editJobProfile: JobProfile;
  /** Edit a key result — no downstream invalidation */
  editKeyResult?: Maybe<Scalars['JSON']['output']>;
  /** Edit a location. Requires MANAGE_ORG_CHART. */
  editLocation: Location;
  /** Edit an objective; for COMPANY level, eagerly invalidates cascade downstream unless isManual is true */
  editObjective?: Maybe<Scalars['JSON']['output']>;
  /** Edit a position through the given draft: nothing is written — each field becomes a reviewable change item (editable: displayName, description, orgId, reportsToPositionId, personId, locationId, jobProfileId, status) and the returned position is the live one with the draft's changes overlaid */
  editPosition: Position;
  /** Edit a strategy input and eagerly invalidate all downstream artifacts */
  editStrategyInput?: Maybe<Scalars['JSON']['output']>;
  /** Edit a theme on the OKR and eagerly invalidate downstream */
  editTheme?: Maybe<Scalars['JSON']['output']>;
  /** Edit a user task (ACL-enforced) */
  editUserTask?: Maybe<Scalars['JSON']['output']>;
  /** Returns the standing open change set for a system lane (AGENT or SYNC), creating it when absent. Admin change sets are created with createOrgChangeSet. Requires MANAGE_ORG_CHART. */
  ensureOrgChangeSet: OrgChangeSet;
  /** The execute button. Flips the session to EXECUTING and runs the agent's work product in the background; returns immediately — poll agentChat for the result, or use POST /agent-chat/{chatId}/execute to stream it instead. */
  executeAgentChat: Agent_Chat_Session;
  grantTypePermission?: Maybe<Scalars['Boolean']['output']>;
  /** Initiate a browser-direct upload. Returns a BrowserUploadSession with a presigned URL (uploadMode: DIRECT) or a SERVER_PROXY session for encrypted tenants. */
  initBrowserUpload?: Maybe<BrowserUploadSession>;
  /** Start an auth flow for a source type (e.g. WORKDAY). Returns a pending connection id and a URL to redirect the user to. The UI never sees the provider. */
  initiateConnectionAuth?: Maybe<ConnectionAuthStart>;
  linkRecord?: Maybe<Scalars['Boolean']['output']>;
  /** Fire async publish of the OKR tree after human review — grants deferred assignee/org-viewer permissions in the background; poll via pollPublish */
  publishOKR?: Maybe<Scalars['Boolean']['output']>;
  /** Publish one or more objectives and their descendant objectives (via parentObjectiveId) */
  publishObjective?: Maybe<Scalars['Boolean']['output']>;
  /** Publishes a draft: preflights every ACCEPTED item against live state (including cross-item cycle checks) and only when all pass applies them through the typed org services. On success the change set becomes PUBLISHED as the next org version. On conflict, the failing items are flagged and nothing applies — review or rebase, then retry. Requires MANAGE_ORG_CHART. */
  publishOrgChangeSet: OrgChangeSet;
  /** The one-call write path for lane writers (HRIS sync, reconciliation agent): resolves the standing AGENT or SYNC lane (creating it when absent) and appends the items to it — writers never create or manage a changeset. Same item shape and merge/drop semantics as addOrgChangeItems; push naively and repeatedly, the counts report what happened. Requires MANAGE_ORG_CHART. */
  pushOrgChangeItems: AddOrgChangeItemsResult;
  /** Thumbs on one transcript turn. Owner-only. true is up, false is down, omit or pass null to clear. Select feedback on messages to read it back. */
  rateAgentChatMessage: Agent_Chat_Message;
  /** Rebases a draft onto the current published truth: every open item's expected base is re-captured and re-preflighted, superseded items are auto-dismissed, and resolved conflicts flip back to ACCEPTED. Use after another change set publishes. Requires MANAGE_ORG_CHART. */
  rebaseOrgChangeSet: OrgChangeSet;
  /** Remove an org from a COMPANY objective's cascadeOrgIds and eagerly invalidate cascade downstream */
  removeOrgAssignment?: Maybe<Scalars['Boolean']['output']>;
  /** Removes an unapplied item from a draft. Requires MANAGE_ORG_CHART. */
  removeOrgChangeItem: OrgChangeSet;
  /** Sets the chat's displayName (middle-rail title). Requires UPDATE on the session (USE_AGENT_CHAT — owner or share). The first user message auto-titles the chat unless it has already been renamed. */
  renameAgentChat: Agent_Chat_Session;
  /** Renames an open admin draft — the title shown in the drafts list. The standing AGENT/SYNC lanes keep their names; published and discarded change sets are immutable. Requires MANAGE_ORG_CHART. */
  renameOrgChangeSet: OrgChangeSet;
  /** Re-sequence a target's bindings; index becomes precedence. */
  reorderIntegrations?: Maybe<Array<Integration>>;
  /** Move an org under a new parent through the given draft — a REPARENT_ORG item lands in the draft; at publish, path and depth are rewritten on the moved node and every ACTIVE descendant, and the moved org's head position is updated to report to the new parent's manager. Requires MANAGE_ORG_CHART functional permission. */
  reparentOrg: Org;
  /** Files a draft as ACCEPTED (acted on) or DISMISSED (not worth acting on), which takes it out of the Actions queue. Nothing is deleted and a draft cannot be reopened. An optional comment is kept on the draft as reviewComment: open the Workflow Builder with the draft id as subjectRef afterwards and it reads the run's output and the comment, and proposes the amendment. */
  resolveAgentDraft: Agent_Draft;
  /** Runs a FAILED workflow run again on the same record: the run flips back to EXECUTING and runs in the background — poll agentChat for the result, or use POST /agent-chat/{chatId}/retry to stream it. Only a workflow run (not a conversation) and only while FAILED. Requires the workflow's permission. */
  retryWorkflowRun: Agent_Chat_Session;
  /** Builds a new ADMIN draft that returns the org to a previous version: the derived inverses of everything published after it, newest first. Items whose targets drifted since are flagged for review instead of pre-accepted. Publish the returned draft to complete the revert. Requires MANAGE_ORG_CHART. */
  revertOrgToVersion: OrgChangeSet;
  /** Builds a new ADMIN draft undoing a single published version (cherry-pick undo). Publish the returned draft to complete the revert. Requires MANAGE_ORG_CHART. */
  revertOrgVersion: OrgChangeSet;
  revokeShare?: Maybe<Scalars['Boolean']['output']>;
  revokeTypePermission?: Maybe<Scalars['Boolean']['output']>;
  /** Run now: one headless run of a workflow as the caller, with values for its inputs (by name; omit to take defaults — a required input with no value is refused here, before anything runs). Returns the run's session already EXECUTING and runs it in the background — poll agentChat for the result, or use POST /agent-chat/workflows/{code}/run to stream it instead. The result lands in Actions like any agent's. Requires the workflow's permission. */
  runWorkflow: Agent_Chat_Session;
  saveActivity?: Maybe<Activity>;
  saveAgent_Action?: Maybe<Agent_Action>;
  saveAnalyticsDashboard?: Maybe<AnalyticsDashboard>;
  /** Create or update a tenant-scoped AnalyticsView */
  saveAnalyticsView?: Maybe<Scalars['JSON']['output']>;
  saveArtifact?: Maybe<Artifact>;
  saveChatBucket?: Maybe<ChatBucket>;
  saveCompany?: Maybe<Company>;
  saveCompanyKnowledge?: Maybe<CompanyKnowledge>;
  /** Create or update a tenant-scoped Dashboard */
  saveDashboard?: Maybe<Scalars['JSON']['output']>;
  saveEdge?: Maybe<Edge>;
  saveExportJobHistory?: Maybe<ExportJobHistory>;
  saveGoal?: Maybe<Goal>;
  saveIdentityLink?: Maybe<IdentityLink>;
  saveInteraction?: Maybe<Interaction>;
  saveKnowledgeNode?: Maybe<KnowledgeNode>;
  saveMetric?: Maybe<Metric>;
  saveMindset?: Maybe<Mindset>;
  saveNote?: Maybe<Note>;
  saveNotification?: Maybe<Notification>;
  saveNotification_Delivery?: Maybe<Notification_Delivery>;
  saveNotification_Outbox?: Maybe<Notification_Outbox>;
  saveNotification_Preference?: Maybe<Notification_Preference>;
  saveNotification_Template?: Maybe<Notification_Template>;
  /** Create or update an OKR */
  saveOkr?: Maybe<Okr>;
  saveOrgRole?: Maybe<OrgRole>;
  saveOutcome?: Maybe<Outcome>;
  savePerson?: Maybe<Person>;
  savePersonKnowledge?: Maybe<PersonKnowledge>;
  /** Save (or clear) the current user's layout/filter override for one dashboard. */
  saveProductivityDashboard?: Maybe<Scalars['JSON']['output']>;
  saveRawChat?: Maybe<RawChat>;
  saveResource?: Maybe<Resource>;
  /** Creates or updates a routine: run workflowCode with these inputs on a cron, as the caller. The caller is the routine's owner — the run executes with their permissions, live, and its results are theirs in Actions — so they must hold the workflow's permission now, and the inputs must satisfy it (a required input with no value, or a name the workflow does not declare, is refused here). Upserts by routineId (document id or bare entity id) — default is one routine per workflow per owner; pass distinct ids for several scopes or cadences. Only the owner can change a routine: an id naming someone else's is refused. MANAGE_ROUTINE required. */
  saveRoutine: Routine;
  saveSkill?: Maybe<Skill>;
  saveSkillGroup?: Maybe<SkillGroup>;
  saveTask?: Maybe<Task>;
  /** Creates or updates an authored agent from a spec (same shape as a *.agent.json file: code, displayName, description, chat instructions, tool and grounding names, requiredPermission, and either an attached workflow code or inline execution fields). The spec is validated against the building-blocks palette before saving — a bad reference is a synchronous error naming the problem. CREATE_CUSTOM_AGENT to create; USE_CUSTOM_AGENT to update an agent you authored. */
  saveTenantAgent: Tenant_Agent;
  saveTenantOntologyPack?: Maybe<TenantOntologyPack>;
  saveUser?: Maybe<User>;
  saveUserDashboardPreference?: Maybe<UserDashboardPreference>;
  saveUserMetricScore?: Maybe<UserMetricScore>;
  saveWorkActivity?: Maybe<WorkActivity>;
  /** One user message → one agent reply, returned with the updated session. Synchronous fallback of POST /agent-chat/{chatId}/messages. */
  sendAgentChatMessage: Agent_Chat_Session;
  /** Set export job status by ID (DEACTIVATED/PENDING) */
  setExportJobStatus?: Maybe<Scalars['JSON']['output']>;
  /** Replace all functional permission grants for an actor (u/, ug/, or r/). Requires MANAGE_PERMISSIONS. */
  setFunctionalPermissions?: Maybe<Array<Maybe<Functional_Permission_Grant>>>;
  setGlobalAccess?: Maybe<Scalars['Boolean']['output']>;
  /** Records the admin's review decision on one item — ACCEPTED or DISMISSED. Applied items are immutable. Requires MANAGE_ORG_CHART. */
  setOrgChangeItemState: OrgChangeSet;
  shareRecord?: Maybe<Scalars['Boolean']['output']>;
  /** Opens a session with an agent and, for one that speaks first, runs its opening turn. Synchronous fallback of POST /agent-chat/start — prefer SSE for the live thinking state. The session carries the chips and title the turn wrote. */
  startAgentChat: Agent_Chat_Session;
  startExport: EntityExportTrigger;
  /** Dismisses an insight for one person, so personInsights stops returning it for them. Per person: it changes nothing for anyone else looking at the same subject. Pass suppressed: false to restore one. Errors when the insight is not about that person. */
  suppressInsight: InsightSuppression;
  transferOwnership?: Maybe<Scalars['Boolean']['output']>;
  /** Fire async AI cascade generation for the confirmed, org-assigned top objectives — Phase 8 */
  triggerCascade?: Maybe<Scalars['Boolean']['output']>;
  /** Fire async AI extraction of company knowledge from the given sources (web search plus uploaded docs) — returns the task id immediately; poll with pollCompanyKnowledge(taskId). Extracted entries are persisted straight to CompanyKnowledge stamped with this task id, then reviewed and edited via CRUD (filter CompanyKnowledge.taskId to this run's entries). Returns null when a job is already running for the tenant and this call is a no-op. */
  triggerCompanyKnowledge?: Maybe<Scalars['ID']['output']>;
  /** Fire async AI web-search discovery that prefills the blank fields of the tenant's Company — returns immediately; poll with pollCompanyProfile */
  triggerCompanyProfile?: Maybe<Scalars['Boolean']['output']>;
  /** Fire async AI web-search discovery of the public pages describing the tenant's company — returns immediately; poll with pollCompanySources. Re-triggering after a finished run replaces the previous list; a call while one is already running is a no-op. */
  triggerCompanySources?: Maybe<Scalars['Boolean']['output']>;
  /** Fire async AI extraction for a strategy input — Phase 2 */
  triggerExtraction?: Maybe<Scalars['Boolean']['output']>;
  /** Fire async AI org assignment for confirmed top objectives — Phase 7 */
  triggerOrgAssignment?: Maybe<Scalars['Boolean']['output']>;
  /** Fire async public knowledge discovery for a person (fast tier) and start the background persist worker — returns immediately; poll with pollPersonKnowledge */
  triggerPersonKnowledge?: Maybe<Scalars['Boolean']['output']>;
  /** Fire async AI generation of bootstrapping strategy questions — Phase 2, an explicit alternative to attaching a strategy document */
  triggerStrategyQuestions?: Maybe<Scalars['Boolean']['output']>;
  /** Fire async AI clarifying-question generation for confirmed themes — Phase 4 */
  triggerThemeQuestions?: Maybe<Scalars['Boolean']['output']>;
  /** Fire async AI theme synthesis across confirmed inputs — Phase 3 */
  triggerThemeSynthesis?: Maybe<Scalars['Boolean']['output']>;
  /** Fire async AI company-level top-objective generation — Phase 5 */
  triggerTopObjectiveGeneration?: Maybe<Scalars['Boolean']['output']>;
  /** Unarchive an entity — for Objective, recursively resets child objectives and key results to DRAFT; for OKRCycle, recursively resets descendant cycles to PLANNING */
  unarchiveEntity?: Maybe<Scalars['Boolean']['output']>;
  unassignGroups?: Maybe<Scalars['Boolean']['output']>;
  /** Removes a job profile's enrolment; individuals enrolled in their own right keep their role. False when the profile held no enrolment to remove. Requires MANAGE_PRODUCTIVITY_MODEL. */
  unassignProductivityRoleFromJobProfile: Scalars['Boolean']['output'];
  /** Removes one person's own enrolment; anyone reached through their job profile keeps that role. False when they held no enrolment to remove. Requires MANAGE_PRODUCTIVITY_MODEL. */
  unassignProductivityRoleFromUser: Scalars['Boolean']['output'];
  unassignRoles?: Maybe<Scalars['Boolean']['output']>;
  unlinkRecord?: Maybe<Scalars['Boolean']['output']>;
  updateActivityById?: Maybe<Activity>;
  updateAgent_ActionById?: Maybe<Agent_Action>;
  updateAnalyticsDashboardById?: Maybe<AnalyticsDashboard>;
  updateArtifactById?: Maybe<Artifact>;
  updateChatBucketById?: Maybe<ChatBucket>;
  updateCompanyById?: Maybe<Company>;
  updateCompanyKnowledgeById?: Maybe<CompanyKnowledge>;
  updateEdgeById?: Maybe<Edge>;
  updateExportJobHistoryById?: Maybe<ExportJobHistory>;
  updateGoalById?: Maybe<Goal>;
  updateIdentityLinkById?: Maybe<IdentityLink>;
  /** Replace a binding's feed-field -> target-field mapping. */
  updateIntegrationMapping?: Maybe<Integration>;
  updateInteractionById?: Maybe<Interaction>;
  updateKnowledgeNodeById?: Maybe<KnowledgeNode>;
  updateMetricById?: Maybe<Metric>;
  updateMindsetById?: Maybe<Mindset>;
  updateNoteById?: Maybe<Note>;
  updateNotificationById?: Maybe<Notification>;
  updateNotification_DeliveryById?: Maybe<Notification_Delivery>;
  updateNotification_OutboxById?: Maybe<Notification_Outbox>;
  updateNotification_PreferenceById?: Maybe<Notification_Preference>;
  updateNotification_TemplateById?: Maybe<Notification_Template>;
  /** Update an OKR cycle */
  updateOKRCycle?: Maybe<Scalars['JSON']['output']>;
  /** Update org fields through the given draft: nothing is written — each field becomes a reviewable change item (editable: displayName, description, parentOrgId, managerPositionId, status) and the returned org is the live one with the draft's changes overlaid. Requires MANAGE_ORG_CHART. */
  updateOrg: Org;
  updateOrgRoleById?: Maybe<OrgRole>;
  updateOutcomeById?: Maybe<Outcome>;
  updatePersonById?: Maybe<Person>;
  updatePersonKnowledgeById?: Maybe<PersonKnowledge>;
  updateRawChatById?: Maybe<RawChat>;
  updateResourceById?: Maybe<Resource>;
  updateRole?: Maybe<App_Role>;
  updateSkillById?: Maybe<Skill>;
  updateSkillGroupById?: Maybe<SkillGroup>;
  updateTaskById?: Maybe<Task>;
  updateTenantOntologyPackById?: Maybe<TenantOntologyPack>;
  updateUserById?: Maybe<User>;
  updateUserDashboardPreferenceById?: Maybe<UserDashboardPreference>;
  updateUserGroup?: Maybe<UserGroup>;
  updateUserMetricScoreById?: Maybe<UserMetricScore>;
  updateWorkActivityById?: Maybe<WorkActivity>;
};


export type MutationAddCheckInArgs = {
  input: Scalars['JSON']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAddCommentArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationAddDepartmentArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationAddInitiativeArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationAddJobFamilyArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationAddJobFamilyGroupArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationAddJobProfileArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationAddKeyResultArgs = {
  assigneePersonId?: InputMaybe<Scalars['ID']['input']>;
  input: Scalars['JSON']['input'];
};


export type MutationAddLocationArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationAddObjectiveArgs = {
  assigneePersonId?: InputMaybe<Scalars['ID']['input']>;
  input: Scalars['JSON']['input'];
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAddOrgAssignmentArgs = {
  objectiveId: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
};


export type MutationAddOrgChangeItemsArgs = {
  changeSetId: Scalars['ID']['input'];
  items: Array<Scalars['JSON']['input']>;
};


export type MutationAddPersonArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationAddPositionArgs = {
  changeSetId: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
};


export type MutationAddStrategyInputArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationAddThemeArgs = {
  okrId: Scalars['ID']['input'];
  theme: Scalars['JSON']['input'];
};


export type MutationAddUserTaskArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationArchiveEntityArgs = {
  entityType: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationAssignGroupsArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId: Scalars['String']['input'];
};


export type MutationAssignProductivityRoleToJobProfileArgs = {
  jobProfileEntityId: Scalars['ID']['input'];
  model: Scalars['String']['input'];
  role: Scalars['String']['input'];
};


export type MutationAssignProductivityRoleToUserArgs = {
  model: Scalars['String']['input'];
  role: Scalars['String']['input'];
  userEntityId: Scalars['ID']['input'];
};


export type MutationAssignRolesArgs = {
  entityId: Scalars['String']['input'];
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationClearFunctionalPermissionsArgs = {
  actor: Scalars['String']['input'];
  functionalPermissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCommitImportArgs = {
  sheets: Scalars['JSON']['input'];
};


export type MutationCompleteConnectionAuthArgs = {
  connectionId: Scalars['ID']['input'];
};


export type MutationConfirmBrowserUploadArgs = {
  actualSize: Scalars['Long']['input'];
  fileId: Scalars['ID']['input'];
};


export type MutationConfirmExtractionArgs = {
  strategyInputId: Scalars['ID']['input'];
};


export type MutationConfirmKnowledgeHealthArgs = {
  okrId: Scalars['ID']['input'];
};


export type MutationConfirmOrgAssignmentsArgs = {
  assignments: Scalars['JSON']['input'];
  okrId: Scalars['ID']['input'];
};


export type MutationConfirmStrategyQuestionsArgs = {
  okrId: Scalars['ID']['input'];
  questions: Scalars['JSON']['input'];
};


export type MutationConfirmThemeAnswersArgs = {
  okrId: Scalars['ID']['input'];
  questions: Scalars['JSON']['input'];
};


export type MutationConfirmThemesArgs = {
  okrId: Scalars['ID']['input'];
  themes: Scalars['JSON']['input'];
};


export type MutationConfirmTopObjectivesArgs = {
  okrId: Scalars['ID']['input'];
};


export type MutationCreateExportJobArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationCreateIntegrationArgs = {
  input: CreateIntegrationInput;
};


export type MutationCreateOkrCycleArgs = {
  quarter?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateOkrShellsArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationCreateOrgArgs = {
  changeSetId: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
};


export type MutationCreateOrgChangeSetArgs = {
  title: Scalars['String']['input'];
};


export type MutationCreateRoleArgs = {
  functionalPermissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  input?: InputMaybe<App_RoleInput>;
};


export type MutationCreateUserGroupArgs = {
  input?: InputMaybe<UserGroupInput>;
};


export type MutationDeleteAgentChatArgs = {
  chatId: Scalars['ID']['input'];
};


export type MutationDeleteAnalyticsViewArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCheckInArgs = {
  checkInId: Scalars['ID']['input'];
};


export type MutationDeleteCommentArgs = {
  commentId: Scalars['ID']['input'];
};


export type MutationDeleteDashboardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDepartmentArgs = {
  departmentId: Scalars['ID']['input'];
};


export type MutationDeleteInitiativeArgs = {
  initiativeId: Scalars['ID']['input'];
};


export type MutationDeleteIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteJobFamilyArgs = {
  jobFamilyId: Scalars['ID']['input'];
};


export type MutationDeleteJobFamilyGroupArgs = {
  jobFamilyGroupId: Scalars['ID']['input'];
};


export type MutationDeleteJobProfileArgs = {
  jobProfileId: Scalars['ID']['input'];
};


export type MutationDeleteKeyResultArgs = {
  keyResultId: Scalars['ID']['input'];
};


export type MutationDeleteLocationArgs = {
  locationId: Scalars['ID']['input'];
};


export type MutationDeleteObjectiveArgs = {
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  objectiveId: Scalars['ID']['input'];
};


export type MutationDeleteOrgArgs = {
  changeSetId: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
};


export type MutationDeletePositionArgs = {
  changeSetId: Scalars['ID']['input'];
  positionId: Scalars['ID']['input'];
};


export type MutationDeleteRoleArgs = {
  roleId: Scalars['String']['input'];
};


export type MutationDeleteRoutineArgs = {
  routineId: Scalars['String']['input'];
};


export type MutationDeleteStoredFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStrategyInputArgs = {
  strategyInputId: Scalars['ID']['input'];
};


export type MutationDeleteTenantAgentArgs = {
  code: Scalars['String']['input'];
};


export type MutationDeleteTenantWorkflowArgs = {
  code: Scalars['String']['input'];
};


export type MutationDeleteThemeArgs = {
  okrId: Scalars['ID']['input'];
  themeId: Scalars['ID']['input'];
};


export type MutationDeleteUserGroupArgs = {
  groupId: Scalars['String']['input'];
};


export type MutationDeleteUserTaskArgs = {
  userTaskId: Scalars['ID']['input'];
};


export type MutationDiscardOrgChangeSetArgs = {
  changeSetId: Scalars['ID']['input'];
};


export type MutationEditCheckInArgs = {
  checkInId: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditClarificationAnswerArgs = {
  answer: Scalars['String']['input'];
  okrId: Scalars['ID']['input'];
  questionId: Scalars['ID']['input'];
};


export type MutationEditCommentArgs = {
  commentId: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
};


export type MutationEditDepartmentArgs = {
  departmentId: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
};


export type MutationEditInitiativeArgs = {
  initiativeId: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
};


export type MutationEditJobFamilyArgs = {
  input: Scalars['JSON']['input'];
  jobFamilyId: Scalars['ID']['input'];
};


export type MutationEditJobFamilyGroupArgs = {
  input: Scalars['JSON']['input'];
  jobFamilyGroupId: Scalars['ID']['input'];
};


export type MutationEditJobProfileArgs = {
  input: Scalars['JSON']['input'];
  jobProfileId: Scalars['ID']['input'];
};


export type MutationEditKeyResultArgs = {
  assigneePersonId?: InputMaybe<Scalars['ID']['input']>;
  input: Scalars['JSON']['input'];
  keyResultId: Scalars['ID']['input'];
};


export type MutationEditLocationArgs = {
  input: Scalars['JSON']['input'];
  locationId: Scalars['ID']['input'];
};


export type MutationEditObjectiveArgs = {
  assigneePersonId?: InputMaybe<Scalars['ID']['input']>;
  input: Scalars['JSON']['input'];
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  objectiveId: Scalars['ID']['input'];
};


export type MutationEditPositionArgs = {
  changeSetId: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
  positionId: Scalars['ID']['input'];
};


export type MutationEditStrategyInputArgs = {
  input: Scalars['JSON']['input'];
  strategyInputId: Scalars['ID']['input'];
};


export type MutationEditThemeArgs = {
  okrId: Scalars['ID']['input'];
  theme: Scalars['JSON']['input'];
};


export type MutationEditUserTaskArgs = {
  input: Scalars['JSON']['input'];
  userTaskId: Scalars['ID']['input'];
};


export type MutationEnsureOrgChangeSetArgs = {
  source: Scalars['String']['input'];
};


export type MutationExecuteAgentChatArgs = {
  chatId: Scalars['ID']['input'];
};


export type MutationGrantTypePermissionArgs = {
  actions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actor: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
};


export type MutationInitBrowserUploadArgs = {
  input: InitBrowserUploadInput;
};


export type MutationInitiateConnectionAuthArgs = {
  sourceType: Scalars['String']['input'];
};


export type MutationLinkRecordArgs = {
  childEntityType: Scalars['String']['input'];
  childId: Scalars['String']['input'];
  parentEntityType: Scalars['String']['input'];
  parentId: Scalars['String']['input'];
};


export type MutationPublishOkrArgs = {
  okrId: Scalars['ID']['input'];
};


export type MutationPublishObjectiveArgs = {
  objectiveIds: Array<Scalars['ID']['input']>;
};


export type MutationPublishOrgChangeSetArgs = {
  changeSetId: Scalars['ID']['input'];
};


export type MutationPushOrgChangeItemsArgs = {
  items: Array<Scalars['JSON']['input']>;
  source: Scalars['String']['input'];
};


export type MutationRateAgentChatMessageArgs = {
  feedback?: InputMaybe<Scalars['Boolean']['input']>;
  messageId: Scalars['ID']['input'];
};


export type MutationRebaseOrgChangeSetArgs = {
  changeSetId: Scalars['ID']['input'];
};


export type MutationRemoveOrgAssignmentArgs = {
  objectiveId: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
};


export type MutationRemoveOrgChangeItemArgs = {
  changeSetId: Scalars['ID']['input'];
  itemId: Scalars['ID']['input'];
};


export type MutationRenameAgentChatArgs = {
  chatId: Scalars['ID']['input'];
  displayName: Scalars['String']['input'];
};


export type MutationRenameOrgChangeSetArgs = {
  changeSetId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};


export type MutationReorderIntegrationsArgs = {
  kind: Scalars['String']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  orderedIds: Array<Scalars['ID']['input']>;
  target: Scalars['String']['input'];
};


export type MutationReparentOrgArgs = {
  changeSetId: Scalars['ID']['input'];
  newParentOrgId: Scalars['ID']['input'];
  orgId: Scalars['ID']['input'];
};


export type MutationResolveAgentDraftArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  draftId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};


export type MutationRetryWorkflowRunArgs = {
  chatId: Scalars['ID']['input'];
};


export type MutationRevertOrgToVersionArgs = {
  version: Scalars['Int']['input'];
};


export type MutationRevertOrgVersionArgs = {
  version: Scalars['Int']['input'];
};


export type MutationRevokeShareArgs = {
  recordPermissionId: Scalars['String']['input'];
};


export type MutationRevokeTypePermissionArgs = {
  typePermissionId: Scalars['String']['input'];
};


export type MutationRunWorkflowArgs = {
  inputs?: InputMaybe<Scalars['JSON']['input']>;
  workflowCode: Scalars['String']['input'];
};


export type MutationSaveActivityArgs = {
  input?: InputMaybe<ActivityInput>;
};


export type MutationSaveAgent_ActionArgs = {
  input?: InputMaybe<Agent_ActionInput>;
};


export type MutationSaveAnalyticsDashboardArgs = {
  input?: InputMaybe<AnalyticsDashboardInput>;
};


export type MutationSaveAnalyticsViewArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationSaveArtifactArgs = {
  input?: InputMaybe<ArtifactInput>;
};


export type MutationSaveChatBucketArgs = {
  input?: InputMaybe<ChatBucketInput>;
};


export type MutationSaveCompanyArgs = {
  input?: InputMaybe<CompanyInput>;
};


export type MutationSaveCompanyKnowledgeArgs = {
  input?: InputMaybe<CompanyKnowledgeInput>;
};


export type MutationSaveDashboardArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationSaveEdgeArgs = {
  input?: InputMaybe<EdgeInput>;
};


export type MutationSaveExportJobHistoryArgs = {
  input?: InputMaybe<ExportJobHistoryInput>;
};


export type MutationSaveGoalArgs = {
  input?: InputMaybe<GoalInput>;
};


export type MutationSaveIdentityLinkArgs = {
  input?: InputMaybe<IdentityLinkInput>;
};


export type MutationSaveInteractionArgs = {
  input?: InputMaybe<InteractionInput>;
};


export type MutationSaveKnowledgeNodeArgs = {
  input?: InputMaybe<KnowledgeNodeInput>;
};


export type MutationSaveMetricArgs = {
  input?: InputMaybe<MetricInput>;
};


export type MutationSaveMindsetArgs = {
  input?: InputMaybe<MindsetInput>;
};


export type MutationSaveNoteArgs = {
  input?: InputMaybe<NoteInput>;
};


export type MutationSaveNotificationArgs = {
  input?: InputMaybe<NotificationInput>;
};


export type MutationSaveNotification_DeliveryArgs = {
  input?: InputMaybe<Notification_DeliveryInput>;
};


export type MutationSaveNotification_OutboxArgs = {
  input?: InputMaybe<Notification_OutboxInput>;
};


export type MutationSaveNotification_PreferenceArgs = {
  input?: InputMaybe<Notification_PreferenceInput>;
};


export type MutationSaveNotification_TemplateArgs = {
  input?: InputMaybe<Notification_TemplateInput>;
};


export type MutationSaveOkrArgs = {
  input: OkrInput;
};


export type MutationSaveOrgRoleArgs = {
  input?: InputMaybe<OrgRoleInput>;
};


export type MutationSaveOutcomeArgs = {
  input?: InputMaybe<OutcomeInput>;
};


export type MutationSavePersonArgs = {
  input?: InputMaybe<PersonInput>;
};


export type MutationSavePersonKnowledgeArgs = {
  input?: InputMaybe<PersonKnowledgeInput>;
};


export type MutationSaveProductivityDashboardArgs = {
  entityType: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  model: Scalars['String']['input'];
  overrides: Scalars['JSON']['input'];
};


export type MutationSaveRawChatArgs = {
  input?: InputMaybe<RawChatInput>;
};


export type MutationSaveResourceArgs = {
  input?: InputMaybe<ResourceInput>;
};


export type MutationSaveRoutineArgs = {
  cron: Scalars['String']['input'];
  inputs?: InputMaybe<Scalars['JSON']['input']>;
  routineId?: InputMaybe<Scalars['String']['input']>;
  tz?: InputMaybe<Scalars['String']['input']>;
  workflowCode: Scalars['String']['input'];
};


export type MutationSaveSkillArgs = {
  input?: InputMaybe<SkillInput>;
};


export type MutationSaveSkillGroupArgs = {
  input?: InputMaybe<SkillGroupInput>;
};


export type MutationSaveTaskArgs = {
  input?: InputMaybe<TaskInput>;
};


export type MutationSaveTenantAgentArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  spec: Scalars['JSON']['input'];
};


export type MutationSaveTenantOntologyPackArgs = {
  input?: InputMaybe<TenantOntologyPackInput>;
};


export type MutationSaveUserArgs = {
  input?: InputMaybe<UserInput>;
};


export type MutationSaveUserDashboardPreferenceArgs = {
  input?: InputMaybe<UserDashboardPreferenceInput>;
};


export type MutationSaveUserMetricScoreArgs = {
  input?: InputMaybe<UserMetricScoreInput>;
};


export type MutationSaveWorkActivityArgs = {
  input?: InputMaybe<WorkActivityInput>;
};


export type MutationSendAgentChatMessageArgs = {
  chatId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


export type MutationSetExportJobStatusArgs = {
  id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};


export type MutationSetFunctionalPermissionsArgs = {
  actor: Scalars['String']['input'];
  functionalPermissions: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationSetGlobalAccessArgs = {
  access: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
};


export type MutationSetOrgChangeItemStateArgs = {
  changeSetId: Scalars['ID']['input'];
  itemId: Scalars['ID']['input'];
  state: Scalars['String']['input'];
};


export type MutationShareRecordArgs = {
  input?: InputMaybe<Record_PermissionInput>;
};


export type MutationStartAgentChatArgs = {
  agentCode: Scalars['String']['input'];
  subjectRef?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationStartExportArgs = {
  input: Scalars['JSON']['input'];
};


export type MutationSuppressInsightArgs = {
  insightId: Scalars['ID']['input'];
  personId: Scalars['ID']['input'];
  suppressed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationTransferOwnershipArgs = {
  entityType: Scalars['String']['input'];
  newOwnerId: Scalars['String']['input'];
  recordId: Scalars['String']['input'];
};


export type MutationTriggerCascadeArgs = {
  okrId: Scalars['ID']['input'];
};


export type MutationTriggerCompanyKnowledgeArgs = {
  fileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  newsUrl?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTriggerCompanyProfileArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationTriggerCompanySourcesArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTriggerExtractionArgs = {
  strategyInputId: Scalars['ID']['input'];
};


export type MutationTriggerOrgAssignmentArgs = {
  okrId: Scalars['ID']['input'];
};


export type MutationTriggerPersonKnowledgeArgs = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  personId: Scalars['ID']['input'];
};


export type MutationTriggerStrategyQuestionsArgs = {
  okrId: Scalars['ID']['input'];
};


export type MutationTriggerThemeQuestionsArgs = {
  okrId: Scalars['ID']['input'];
};


export type MutationTriggerThemeSynthesisArgs = {
  okrId: Scalars['ID']['input'];
  timeHorizon?: InputMaybe<Scalars['String']['input']>;
};


export type MutationTriggerTopObjectiveGenerationArgs = {
  okrId: Scalars['ID']['input'];
};


export type MutationUnarchiveEntityArgs = {
  entityType: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUnassignGroupsArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId: Scalars['String']['input'];
};


export type MutationUnassignProductivityRoleFromJobProfileArgs = {
  jobProfileEntityId: Scalars['ID']['input'];
};


export type MutationUnassignProductivityRoleFromUserArgs = {
  userEntityId: Scalars['ID']['input'];
};


export type MutationUnassignRolesArgs = {
  entityId: Scalars['String']['input'];
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUnlinkRecordArgs = {
  membershipId: Scalars['String']['input'];
};


export type MutationUpdateActivityByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateAgent_ActionByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateAnalyticsDashboardByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateArtifactByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateChatBucketByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateCompanyByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateCompanyKnowledgeByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateEdgeByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateExportJobHistoryByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateGoalByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateIdentityLinkByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateIntegrationMappingArgs = {
  id: Scalars['ID']['input'];
  mapping: Scalars['JSON']['input'];
};


export type MutationUpdateInteractionByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateKnowledgeNodeByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateMetricByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateMindsetByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateNoteByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateNotificationByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateNotification_DeliveryByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateNotification_OutboxByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateNotification_PreferenceByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateNotification_TemplateByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateOkrCycleArgs = {
  cycleId: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
};


export type MutationUpdateOrgArgs = {
  changeSetId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: Scalars['JSON']['input'];
};


export type MutationUpdateOrgRoleByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateOutcomeByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdatePersonByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdatePersonKnowledgeByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateRawChatByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateResourceByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateRoleArgs = {
  functionalPermissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  input?: InputMaybe<App_RoleInput>;
};


export type MutationUpdateSkillByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateSkillGroupByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateTaskByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateTenantOntologyPackByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateUserByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateUserDashboardPreferenceByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateUserGroupArgs = {
  input?: InputMaybe<UserGroupInput>;
};


export type MutationUpdateUserMetricScoreByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};


export type MutationUpdateWorkActivityByIdArgs = {
  id: Scalars['ID']['input'];
  updates?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
};

/** A standalone, longer-form rich-text annotation attached to any entity — generic, polymorphic; title is the inherited displayName */
export type Note = BaseEntity & {
  __typename?: 'Note';
  authorPersonId?: Maybe<Person>;
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  mentionedPersonIds?: Maybe<Array<Maybe<Person>>>;
  pinned?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  targetRef?: Maybe<BaseEntity>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type NoteInput = {
  authorPersonId?: InputMaybe<Scalars['ID']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  mentionedPersonIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  targetRef?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a NoteList query */
export type NoteListResult = {
  __typename?: 'NoteListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Note>>>;
  /** Total number of Note records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A per-recipient notification-center inbox item with read/unread state. */
export type Notification = BaseEntity & {
  __typename?: 'Notification';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deepLink?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  eventKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  priority?: Maybe<Scalars['String']['output']>;
  readAt?: Maybe<Scalars['Long']['output']>;
  recipientUserId?: Maybe<Scalars['String']['output']>;
  sourceOutboxId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subjectId?: Maybe<Scalars['String']['output']>;
  subjectType?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type NotificationInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deepLink?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  eventKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  readAt?: InputMaybe<Scalars['Long']['input']>;
  recipientUserId?: InputMaybe<Scalars['String']['input']>;
  sourceOutboxId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subjectId?: InputMaybe<Scalars['String']['input']>;
  subjectType?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a NotificationList query */
export type NotificationListResult = {
  __typename?: 'NotificationListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Notification>>>;
  /** Total number of Notification records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Per (recipient × channel) delivery record tracking status and provider reference. */
export type Notification_Delivery = BaseEntity & {
  __typename?: 'Notification_Delivery';
  address?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  nextRetryAt?: Maybe<Scalars['Long']['output']>;
  providerRef?: Maybe<Scalars['String']['output']>;
  recipientUserId?: Maybe<Scalars['String']['output']>;
  retryCount?: Maybe<Scalars['Int']['output']>;
  skipReason?: Maybe<Scalars['String']['output']>;
  sourceOutboxId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type Notification_DeliveryInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  nextRetryAt?: InputMaybe<Scalars['Long']['input']>;
  providerRef?: InputMaybe<Scalars['String']['input']>;
  recipientUserId?: InputMaybe<Scalars['String']['input']>;
  retryCount?: InputMaybe<Scalars['Int']['input']>;
  skipReason?: InputMaybe<Scalars['String']['input']>;
  sourceOutboxId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a Notification_DeliveryList query */
export type Notification_DeliveryListResult = {
  __typename?: 'Notification_DeliveryListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Notification_Delivery>>>;
  /** Total number of Notification_Delivery records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A queued semantic notification request, fanned out into per-recipient deliveries by core-notification-server. */
export type Notification_Outbox = BaseEntity & {
  __typename?: 'Notification_Outbox';
  actorUserId?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  channels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  data?: Maybe<Scalars['JSON']['output']>;
  deepLink?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  eventKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  priority?: Maybe<Scalars['String']['output']>;
  processingError?: Maybe<Scalars['String']['output']>;
  recipientOrgIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  recipientUserIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
  subjectId?: Maybe<Scalars['String']['output']>;
  subjectType?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type Notification_OutboxInput = {
  actorUserId?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  channels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  deepLink?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  eventKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  processingError?: InputMaybe<Scalars['String']['input']>;
  recipientOrgIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recipientUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  subjectId?: InputMaybe<Scalars['String']['input']>;
  subjectType?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a Notification_OutboxList query */
export type Notification_OutboxListResult = {
  __typename?: 'Notification_OutboxListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Notification_Outbox>>>;
  /** Total number of Notification_Outbox records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A recipient's per-event channel opt-ins, digest mode, and quiet hours. */
export type Notification_Preference = BaseEntity & {
  __typename?: 'Notification_Preference';
  ALL_EVENTS?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  digestMode?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabledChannels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  eventKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  quietHoursEnd?: Maybe<Scalars['Long']['output']>;
  quietHoursStart?: Maybe<Scalars['Long']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type Notification_PreferenceInput = {
  ALL_EVENTS?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  digestMode?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabledChannels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  eventKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  quietHoursEnd?: InputMaybe<Scalars['Long']['input']>;
  quietHoursStart?: InputMaybe<Scalars['Long']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a Notification_PreferenceList query */
export type Notification_PreferenceListResult = {
  __typename?: 'Notification_PreferenceListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Notification_Preference>>>;
  /** Total number of Notification_Preference records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Rendering template for an (eventKey, channel, locale) combination. */
export type Notification_Template = BaseEntity & {
  __typename?: 'Notification_Template';
  CONNECTION_REF?: Maybe<Scalars['String']['output']>;
  DEFAULT_LOCALE?: Maybe<Scalars['String']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  bodyTemplate?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  eventKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  locale?: Maybe<Scalars['String']['output']>;
  subjectTemplate?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type Notification_TemplateInput = {
  CONNECTION_REF?: InputMaybe<Scalars['String']['input']>;
  DEFAULT_LOCALE?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bodyTemplate?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  eventKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  subjectTemplate?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a Notification_TemplateList query */
export type Notification_TemplateListResult = {
  __typename?: 'Notification_TemplateListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Notification_Template>>>;
  /** Total number of Notification_Template records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Root of an OKR tree — holds type, ownership, generation wizard state, and the embedded generation context */
export type Okr = BaseEntity & {
  __typename?: 'OKR';
  clarifications?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  confidential?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  cycleId?: Maybe<OkrCycle>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  generationStatus?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  objectiveIds?: Maybe<Array<Maybe<Objective>>>;
  orgId?: Maybe<Org>;
  ownerIds?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  parentOkrId?: Maybe<Okr>;
  status?: Maybe<Scalars['String']['output']>;
  strategyInputIds?: Maybe<Array<Maybe<StrategyInput>>>;
  strategyQuestions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  themes?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

/** A planning and review period for OKRs — lean period definition; generation wizard state lives on each OKR */
export type OkrCycle = BaseEntity & {
  __typename?: 'OKRCycle';
  cadence?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['Long']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  parentCycleId?: Maybe<OkrCycle>;
  startDate?: Maybe<Scalars['Long']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

/** Paginated result of a OKRCycleList query */
export type OkrCycleListResult = {
  __typename?: 'OKRCycleListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<OkrCycle>>>;
  /** Total number of OKRCycle records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type OkrInput = {
  clarifications?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  confidential?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  cycleId?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  generationStatus?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  objectiveIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  ownerIds?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  parentOkrId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  strategyInputIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  strategyQuestions?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  themes?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a OKRList query */
export type OkrListResult = {
  __typename?: 'OKRListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Okr>>>;
  /** Total number of OKR records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A qualitative goal within an OKR tree — holds the specific goal wording, level, and org/position assignment */
export type Objective = BaseEntity & {
  __typename?: 'Objective';
  /** User assigned via ASSIGN_OBJECTIVE, including grant template/actions and person details — null when no user assignee grant exists */
  assignee?: Maybe<Scalars['JSON']['output']>;
  cascadeOrgIds?: Maybe<Array<Maybe<Org>>>;
  /** Count of direct child key results (keyResultIds.size()) */
  childKeyResultsCount?: Maybe<Scalars['Int']['output']>;
  childObjectiveIds?: Maybe<Array<Maybe<Objective>>>;
  /** Count of direct child objectives (childObjectiveIds.size()) */
  childObjectivesCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  cycleId?: Maybe<OkrCycle>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['Long']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  keyResultIds?: Maybe<Array<Maybe<KeyResult>>>;
  /** Key results visible to the current user grouped by status — includes key results on descendant objectives */
  keyResultsGroupedByStatus?: Maybe<Scalars['JSON']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  level?: Maybe<Scalars['String']['output']>;
  okrId?: Maybe<Okr>;
  orgId?: Maybe<Org>;
  parentObjectiveId?: Maybe<Objective>;
  positionId?: Maybe<Position>;
  progress?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  themeId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

/** Paginated result of a ObjectiveList query */
export type ObjectiveListResult = {
  __typename?: 'ObjectiveListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  /** Count of scoped objectives the context user cannot read — all matching objectives minus those visible to the current user. Populated by rootLevelObjectives (POSITIONED) and objectiveListForPosition; 0 on other objective list queries. */
  hiddenObjectiveCount?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Maybe<Objective>>>;
  /** Total number of Objective records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Which objective visibility fetch to scope rootLevelObjectives to */
export enum ObjectiveScope {
  All = 'ALL',
  My = 'MY',
  Positioned = 'POSITIONED',
  Team = 'TEAM'
}

/** Aggregate counts for an OKR tree */
export type OkrStats = {
  __typename?: 'OkrStats';
  /** Total COMPANY-level objectives in this OKR */
  companyObjectiveCount?: Maybe<Scalars['Int']['output']>;
  /** Total key results under objectives belonging to this OKR */
  keyResultCount?: Maybe<Scalars['Int']['output']>;
  /** OKR id these counts belong to */
  okrId: Scalars['ID']['output'];
  /** Total ORG-level objectives in this OKR */
  orgObjectiveCount?: Maybe<Scalars['Int']['output']>;
  /** Distinct non-null position ids from Objective.positionId and KeyResult.ownerPositionId in this OKR */
  uniquePositionCount?: Maybe<Scalars['Int']['output']>;
};

/** Supervisory org unit in the organizational hierarchy */
export type Org = BaseEntity & {
  __typename?: 'Org';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  depth?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  iconColour?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  managerPositionId?: Maybe<Position>;
  /** Deepest depth value among this org's ACTIVE descendants, or null when it has none. Computed on demand — only when the field is actually queried — and batched across the page via a DataLoader, so listing N orgs costs one extra query rather than N. */
  maxChildDepth?: Maybe<Scalars['Int']['output']>;
  orgType?: Maybe<Scalars['String']['output']>;
  parentOrgId?: Maybe<Org>;
  path?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

/** Reviewable batch of atomic org-structure changes; each published change set is one org version */
export type OrgChangeSet = BaseEntity & {
  __typename?: 'OrgChangeSet';
  agentCode?: Maybe<Scalars['String']['output']>;
  agentName?: Maybe<Scalars['String']['output']>;
  baseVersion?: Maybe<Scalars['Int']['output']>;
  chatId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  items?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  orgVersion?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['Long']['output']>;
  publishedBy?: Maybe<Scalars['String']['output']>;
  revertsToVersion?: Maybe<Scalars['Int']['output']>;
  routineId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
  workflowCode?: Maybe<Scalars['String']['output']>;
};

export type OrgInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  depth?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  iconColour?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  managerPositionId?: InputMaybe<Scalars['ID']['input']>;
  orgType?: InputMaybe<Scalars['String']['input']>;
  parentOrgId?: InputMaybe<Scalars['ID']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a OrgList query */
export type OrgListResult = {
  __typename?: 'OrgListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Org>>>;
  /** Total number of Org records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Organizational role entity representing a position within a department */
export type OrgRole = BaseEntity & {
  __typename?: 'OrgRole';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  departmentId?: Maybe<Department>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isMGSAenabled?: Maybe<Scalars['Boolean']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  roleType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type OrgRoleInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isMGSAenabled?: InputMaybe<Scalars['Boolean']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  roleType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a OrgRoleList query */
export type OrgRoleListResult = {
  __typename?: 'OrgRoleListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<OrgRole>>>;
  /** Total number of OrgRole records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Per-item verdict of a simulation, in apply order */
export type OrgSimulatedItem = {
  __typename?: 'OrgSimulatedItem';
  /** Why the item cannot apply — null when it projects cleanly */
  conflict?: Maybe<Scalars['String']['output']>;
  itemId: Scalars['ID']['output'];
  /** OrgChangeOp name */
  op: Scalars['String']['output'];
  /** Full document id of the entity the op acts on */
  targetId: Scalars['ID']['output'];
};

/** What the org would look like if the selected items were published right now */
export type OrgSimulationResult = {
  __typename?: 'OrgSimulationResult';
  /** True when every selected item projects without conflict */
  clean: Scalars['Boolean']['output'];
  items?: Maybe<Array<Maybe<OrgSimulatedItem>>>;
  /** Target document id → the fields (and values) that would change; overlay this diff on the currently rendered tree */
  projected?: Maybe<Scalars['JSON']['output']>;
};

/** Outcome entity for tracking sales results and achievements */
export type Outcome = BaseEntity & {
  __typename?: 'Outcome';
  activityId?: Maybe<Activity>;
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  model?: Maybe<Scalars['String']['output']>;
  outcomeType?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceRef?: Maybe<Scalars['String']['output']>;
  subjectIds?: Maybe<Array<Maybe<BaseEntity>>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['Long']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type OutcomeInput = {
  activityId?: InputMaybe<Scalars['ID']['input']>;
  confidence?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  outcomeType?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceRef?: InputMaybe<Scalars['String']['input']>;
  subjectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['Long']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a OutcomeList query */
export type OutcomeListResult = {
  __typename?: 'OutcomeListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Outcome>>>;
  /** Total number of Outcome records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ParsedSheet = {
  __typename?: 'ParsedSheet';
  headers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  rows?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** The entity type this sheet imports, e.g. "Org", "Position". */
  sheetName: Scalars['String']['output'];
};

export type ParsedWorkbook = {
  __typename?: 'ParsedWorkbook';
  fileId: Scalars['ID']['output'];
  sheets?: Maybe<Array<Maybe<ParsedSheet>>>;
};

export type Permission_Template = BaseEntity & {
  __typename?: 'Permission_Template';
  childrenRules?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  resourceType?: Maybe<Scalars['String']['output']>;
  selfRules?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

/** Person entity representing a measured subject */
export type Person = BaseEntity & {
  __typename?: 'Person';
  activeFlag?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  dateOfBirth?: Maybe<Scalars['Long']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  departmentId?: Maybe<Department>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  dottedLineManagerId?: Maybe<Person>;
  emailAliases?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  exitDate?: Maybe<Scalars['Long']['output']>;
  federationId?: Maybe<Scalars['String']['output']>;
  hierarchyPath?: Maybe<Scalars['String']['output']>;
  hireDate?: Maybe<Scalars['Long']['output']>;
  id: Scalars['ID']['output'];
  jobProfileId?: Maybe<JobProfile>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  managerPersonId?: Maybe<Person>;
  orgPath?: Maybe<Scalars['String']['output']>;
  orgRoleId?: Maybe<OrgRole>;
  personCode?: Maybe<Scalars['String']['output']>;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryPhone?: Maybe<Scalars['String']['output']>;
  primaryPositionId?: Maybe<Position>;
  profilePicture?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  /** Stable unique identifier for the person: federationId when present, otherwise primaryEmail. */
  uniqueId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type PersonInput = {
  activeFlag?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Long']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  departmentId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  dottedLineManagerId?: InputMaybe<Scalars['ID']['input']>;
  emailAliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  exitDate?: InputMaybe<Scalars['Long']['input']>;
  federationId?: InputMaybe<Scalars['String']['input']>;
  hierarchyPath?: InputMaybe<Scalars['String']['input']>;
  hireDate?: InputMaybe<Scalars['Long']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobProfileId?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  managerPersonId?: InputMaybe<Scalars['ID']['input']>;
  orgPath?: InputMaybe<Scalars['String']['input']>;
  orgRoleId?: InputMaybe<Scalars['ID']['input']>;
  personCode?: InputMaybe<Scalars['String']['input']>;
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  primaryPhone?: InputMaybe<Scalars['String']['input']>;
  primaryPositionId?: InputMaybe<Scalars['ID']['input']>;
  profilePicture?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** A knowledge entry about a person — feeds the Lyearn profile card and the MGSA cold start */
export type PersonKnowledge = BaseEntity & {
  __typename?: 'PersonKnowledge';
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  mgsaDimension?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Person>;
  source?: Maybe<Scalars['String']['output']>;
  sourceDate?: Maybe<Scalars['Long']['output']>;
  sourceRef?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type PersonKnowledgeInput = {
  confidence?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  mgsaDimension?: InputMaybe<Scalars['String']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceDate?: InputMaybe<Scalars['Long']['input']>;
  sourceRef?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a PersonKnowledgeList query */
export type PersonKnowledgeListResult = {
  __typename?: 'PersonKnowledgeListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<PersonKnowledge>>>;
  /** Total number of PersonKnowledge records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Paginated result of a PersonList query */
export type PersonListResult = {
  __typename?: 'PersonListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Person>>>;
  /** Total number of Person records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Instance of a JobProfile placed within the org hierarchy */
export type Position = BaseEntity & {
  __typename?: 'Position';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  employmentStatus?: Maybe<Scalars['String']['output']>;
  employmentType?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobProfileId?: Maybe<JobProfile>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  locationId?: Maybe<Location>;
  orgId?: Maybe<Org>;
  orgPath?: Maybe<Scalars['String']['output']>;
  personId?: Maybe<Person>;
  reportsToPositionId?: Maybe<Position>;
  requisitionId?: Maybe<Requisition>;
  responsibilities?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type PositionInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<Scalars['String']['input']>;
  employmentType?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobProfileId?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  orgPath?: InputMaybe<Scalars['String']['input']>;
  personId?: InputMaybe<Scalars['ID']['input']>;
  reportsToPositionId?: InputMaybe<Scalars['ID']['input']>;
  requisitionId?: InputMaybe<Scalars['ID']['input']>;
  responsibilities?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a PositionList query */
export type PositionListResult = {
  __typename?: 'PositionListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Position>>>;
  /** Total number of Position records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Declarative definition of a productivity model (roles + ontology) */
export type ProductivityModelDefinition = BaseEntity & {
  __typename?: 'ProductivityModelDefinition';
  agents?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  analyses?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  evidence?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  metrics?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  mgsa?: Maybe<Scalars['JSON']['output']>;
  modelVersion?: Maybe<Scalars['Int']['output']>;
  ontology?: Maybe<Scalars['JSON']['output']>;
  populations?: Maybe<Scalars['JSON']['output']>;
  processes?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  roles?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type Query = {
  __typename?: 'Query';
  Activity?: Maybe<Activity>;
  ActivityList?: Maybe<Array<Maybe<Activity>>>;
  ActivityPaginatedList?: Maybe<ActivityListResult>;
  Agent_Action?: Maybe<Agent_Action>;
  Agent_ActionList?: Maybe<Array<Maybe<Agent_Action>>>;
  Agent_ActionPaginatedList?: Maybe<Agent_ActionListResult>;
  AnalyticsDashboard?: Maybe<AnalyticsDashboard>;
  AnalyticsDashboardList?: Maybe<Array<Maybe<AnalyticsDashboard>>>;
  AnalyticsDashboardPaginatedList?: Maybe<AnalyticsDashboardListResult>;
  Artifact?: Maybe<Artifact>;
  ArtifactList?: Maybe<Array<Maybe<Artifact>>>;
  ArtifactPaginatedList?: Maybe<ArtifactListResult>;
  ChatBucket?: Maybe<ChatBucket>;
  ChatBucketList?: Maybe<Array<Maybe<ChatBucket>>>;
  ChatBucketPaginatedList?: Maybe<ChatBucketListResult>;
  /** List comments visible to the current user (ACL-enforced) */
  CommentList?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  Company?: Maybe<Company>;
  CompanyKnowledge?: Maybe<CompanyKnowledge>;
  CompanyKnowledgeList?: Maybe<Array<Maybe<CompanyKnowledge>>>;
  CompanyKnowledgePaginatedList?: Maybe<CompanyKnowledgeListResult>;
  CompanyList?: Maybe<Array<Maybe<Company>>>;
  CompanyPaginatedList?: Maybe<CompanyListResult>;
  /** List departments visible to the current user (ACL-enforced) */
  DepartmentList?: Maybe<Array<Maybe<Department>>>;
  Edge?: Maybe<Edge>;
  EdgeList?: Maybe<Array<Maybe<Edge>>>;
  EdgePaginatedList?: Maybe<EdgeListResult>;
  /** Peek (and seed if missing) the next entity code for a sourceEntityType */
  EntityCodeLookupList: EntityCodeLookupListResult;
  ExportJobHistory?: Maybe<ExportJobHistory>;
  ExportJobHistoryList?: Maybe<Array<Maybe<ExportJobHistory>>>;
  ExportJobHistoryPaginatedList?: Maybe<ExportJobHistoryListResult>;
  Goal?: Maybe<Goal>;
  GoalList?: Maybe<Array<Maybe<Goal>>>;
  GoalPaginatedList?: Maybe<GoalListResult>;
  IdentityLink?: Maybe<IdentityLink>;
  IdentityLinkList?: Maybe<Array<Maybe<IdentityLink>>>;
  IdentityLinkPaginatedList?: Maybe<IdentityLinkListResult>;
  Interaction?: Maybe<Interaction>;
  InteractionList?: Maybe<Array<Maybe<Interaction>>>;
  InteractionPaginatedList?: Maybe<InteractionListResult>;
  /** List job family groups visible to the current user (ACL-enforced) */
  JobFamilyGroupList?: Maybe<JobFamilyGroupListResult>;
  /** List job families visible to the current user (ACL-enforced) */
  JobFamilyList?: Maybe<JobFamilyListResult>;
  /** List job profiles visible to the current user (ACL-enforced) */
  JobProfileList?: Maybe<JobProfileListResult>;
  /** List key results visible to the current user (ACL-enforced) */
  KeyResultList?: Maybe<Array<Maybe<KeyResult>>>;
  KnowledgeNode?: Maybe<KnowledgeNode>;
  KnowledgeNodeList?: Maybe<Array<Maybe<KnowledgeNode>>>;
  KnowledgeNodePaginatedList?: Maybe<KnowledgeNodeListResult>;
  Metric?: Maybe<Metric>;
  MetricList?: Maybe<Array<Maybe<Metric>>>;
  MetricPaginatedList?: Maybe<MetricListResult>;
  Mindset?: Maybe<Mindset>;
  MindsetList?: Maybe<Array<Maybe<Mindset>>>;
  MindsetPaginatedList?: Maybe<MindsetListResult>;
  Note?: Maybe<Note>;
  NoteList?: Maybe<Array<Maybe<Note>>>;
  NotePaginatedList?: Maybe<NoteListResult>;
  Notification?: Maybe<Notification>;
  NotificationList?: Maybe<Array<Maybe<Notification>>>;
  NotificationPaginatedList?: Maybe<NotificationListResult>;
  Notification_Delivery?: Maybe<Notification_Delivery>;
  Notification_DeliveryList?: Maybe<Array<Maybe<Notification_Delivery>>>;
  Notification_DeliveryPaginatedList?: Maybe<Notification_DeliveryListResult>;
  Notification_Outbox?: Maybe<Notification_Outbox>;
  Notification_OutboxList?: Maybe<Array<Maybe<Notification_Outbox>>>;
  Notification_OutboxPaginatedList?: Maybe<Notification_OutboxListResult>;
  Notification_Preference?: Maybe<Notification_Preference>;
  Notification_PreferenceList?: Maybe<Array<Maybe<Notification_Preference>>>;
  Notification_PreferencePaginatedList?: Maybe<Notification_PreferenceListResult>;
  Notification_Template?: Maybe<Notification_Template>;
  Notification_TemplateList?: Maybe<Array<Maybe<Notification_Template>>>;
  Notification_TemplatePaginatedList?: Maybe<Notification_TemplateListResult>;
  /** List OKR cycles visible to the current user (ACL-enforced) — paginated result with items, totalCount, and hasNextPage */
  OKRCycleList?: Maybe<OkrCycleListResult>;
  /** List Objective records for the current tenant — paginated result with items, totalCount, and hasNextPage */
  ObjectiveList?: Maybe<ObjectiveListResult>;
  /** List orgs matching the given filter criteria (parentOrgId, pathPrefix, status, depth, etc.) */
  OrgList?: Maybe<OrgListResult>;
  OrgRole?: Maybe<OrgRole>;
  OrgRoleList?: Maybe<Array<Maybe<OrgRole>>>;
  OrgRolePaginatedList?: Maybe<OrgRoleListResult>;
  Outcome?: Maybe<Outcome>;
  OutcomeList?: Maybe<Array<Maybe<Outcome>>>;
  OutcomePaginatedList?: Maybe<OutcomeListResult>;
  Person?: Maybe<Person>;
  PersonKnowledge?: Maybe<PersonKnowledge>;
  PersonKnowledgeList?: Maybe<Array<Maybe<PersonKnowledge>>>;
  PersonKnowledgePaginatedList?: Maybe<PersonKnowledgeListResult>;
  PersonList?: Maybe<Array<Maybe<Person>>>;
  PersonPaginatedList?: Maybe<PersonListResult>;
  /** List positions visible to the current user (ACL-enforced) */
  PositionList?: Maybe<PositionListResult>;
  RawChat?: Maybe<RawChat>;
  RawChatList?: Maybe<Array<Maybe<RawChat>>>;
  RawChatPaginatedList?: Maybe<RawChatListResult>;
  Resource?: Maybe<Resource>;
  ResourceList?: Maybe<Array<Maybe<Resource>>>;
  ResourcePaginatedList?: Maybe<ResourceListResult>;
  Skill?: Maybe<Skill>;
  SkillGroup?: Maybe<SkillGroup>;
  SkillGroupList?: Maybe<Array<Maybe<SkillGroup>>>;
  SkillGroupPaginatedList?: Maybe<SkillGroupListResult>;
  SkillList?: Maybe<Array<Maybe<Skill>>>;
  SkillPaginatedList?: Maybe<SkillListResult>;
  Task?: Maybe<Task>;
  TaskList?: Maybe<Array<Maybe<Task>>>;
  TaskPaginatedList?: Maybe<TaskListResult>;
  TenantOntologyPack?: Maybe<TenantOntologyPack>;
  TenantOntologyPackList?: Maybe<Array<Maybe<TenantOntologyPack>>>;
  TenantOntologyPackPaginatedList?: Maybe<TenantOntologyPackListResult>;
  User?: Maybe<User>;
  UserDashboardPreference?: Maybe<UserDashboardPreference>;
  UserDashboardPreferenceList?: Maybe<Array<Maybe<UserDashboardPreference>>>;
  UserDashboardPreferencePaginatedList?: Maybe<UserDashboardPreferenceListResult>;
  UserList?: Maybe<Array<Maybe<User>>>;
  UserMetricScore?: Maybe<UserMetricScore>;
  UserMetricScoreList?: Maybe<Array<Maybe<UserMetricScore>>>;
  UserMetricScorePaginatedList?: Maybe<UserMetricScoreListResult>;
  UserPaginatedList?: Maybe<UserListResult>;
  /** List user tasks visible to the current user (ACL-enforced) */
  UserTaskList?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  WorkActivity?: Maybe<WorkActivity>;
  WorkActivityList?: Maybe<Array<Maybe<WorkActivity>>>;
  WorkActivityPaginatedList?: Maybe<WorkActivityListResult>;
  /** The Actions queue, newest first: open org change sets and open agent drafts (briefings) merged into one list, in the standard page envelope { items, totalCount, hasNextPage }. Drafts require USE_AGENT_DRAFT (own createdBy only); change sets still require MANAGE_ORG_CHART. Each card names the agent and the chat behind it when an agent produced it, and carries the artifact itself under changeSet or draft — select both and render the one that arrives. */
  agentActions?: Maybe<AgentActionListResult>;
  /** The agent-builder's palette: the tools, grounding providers and prompt fragments an authored agent may reference (each with a description to pick it by), plus the permissions a spec may require. CREATE_CUSTOM_AGENT required. */
  agentBuildingBlocks: Scalars['JSON']['output'];
  /** One chat session by id — transcript, status, readiness, and the result envelope once executed. The history view's fetch, and the poll target while an execution runs. */
  agentChat: Agent_Chat_Session;
  /** The agents a chat can be opened with — the picker's list. Each carries its execute-button label and the kind of artifact it produces. The list lives in memory, so the knobs are named rather than Predicate JSON: search matches code, displayName and description case-insensitively. Offset applies before limit. */
  agentChatCatalog?: Maybe<Array<Maybe<AgentChatAgent>>>;
  /** Short summary of the conversation — getOrCreate: cached until the transcript moves, then recomputed. Empty string for an empty chat. */
  agentChatSummary: Scalars['String']['output'];
  /** One agent draft by id — the review screen's fetch. Requires USE_AGENT_DRAFT (own createdBy only), and a producing agent this user may use. Errors indistinguishably when the id is unknown or not visible. */
  agentDraft: Agent_Draft;
  /** Group and aggregate records for any entity type */
  aggregate?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Union of myKeyResultList and visibleToOrgKeyResultList — all key results the current user can see, deduplicated */
  allKeyResultList?: Maybe<Array<Maybe<KeyResult>>>;
  /** Load a saved AnalyticsView by ID */
  analyticsView?: Maybe<Scalars['JSON']['output']>;
  /** List AnalyticsViews owned by or shared with the current user */
  analyticsViewListAll?: Maybe<Array<Maybe<AnalyticsView>>>;
  /** List AnalyticsViews owned by the current user */
  analyticsViewListOwned?: Maybe<Array<Maybe<AnalyticsView>>>;
  /** List AnalyticsViews shared with the current user but owned by someone else */
  analyticsViewListShared?: Maybe<Array<Maybe<AnalyticsView>>>;
  /** List saved AnalyticsViews for a report definition */
  analyticsViews?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  auditLogForEntity?: Maybe<Array<Maybe<Audit_Log>>>;
  /** List check-ins visible to the current user (ACL-enforced) */
  checkInList?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** The cockpit summary widgets + a paged, per-row-resolved rows for a collection dashboard. */
  collectionView?: Maybe<Scalars['JSON']['output']>;
  /** The available declarative connectors and the feeds they provide. */
  connectors?: Maybe<Array<Connector>>;
  /** Highest published org version number; 0 when nothing has been published. The version shown on top of the Org Structure page. */
  currentOrgVersion: Scalars['Int']['output'];
  /** Load a saved Dashboard by ID */
  dashboard?: Maybe<Scalars['JSON']['output']>;
  /** The profile CTA row — one entry per productivity model enabled for the tenant that declares a collection dashboard with an `entry` block. */
  dashboardEntries?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** The pure DashboardSpec layout (cacheable) for one (model, kind, entityType), with any saved per-user preference shallow-merged in. Includes free-form uiConfig JSON when the spec declares it. */
  dashboardLayout?: Maybe<Scalars['JSON']['output']>;
  /** List dashboards for the current tenant, optionally filtered by type and paginated */
  dashboards?: Maybe<DashboardListResult>;
  /** The tenant's own copies of the productivity model definitions it has enabled — the source of display metadata (displayName, description, unit, category) for the bare metric names and MGSA formula codes that scores are keyed by. */
  enabledProductivityModelDefinitions?: Maybe<Array<Maybe<ProductivityModelDefinition>>>;
  /** Productivity model names enabled for the current tenant (from tenant-scoped assignments).  */
  enabledProductivityModelNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Execute a report query and return paginated rows */
  executeReport?: Maybe<Scalars['JSON']['output']>;
  /** Poll an export job for status and download URL */
  exportJob?: Maybe<Scalars['JSON']['output']>;
  /** List export jobs for the current tenant, optionally scoped to a report definition or a specific report/dashboard */
  exportJobs?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  exportStatus?: Maybe<EntityExportStatus>;
  /** Get download routing for a StoredFile. Returns a presigned URL for non-encrypted files (mode: DIRECT_URL) or SERVER_PROXY for encrypted files that must be streamed through the server. */
  fileDownloadInfo?: Maybe<FileDownloadInfo>;
  importJobStatus?: Maybe<Scalars['JSON']['output']>;
  /** List initiatives visible to the current user (ACL-enforced) */
  initiativeList?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Connected connections for a source type — the reuse picker's options. */
  integrationConnections?: Maybe<Array<IntegrationConnectionSummary>>;
  /** Bindings under a catalog target, in precedence order. */
  integrationsForTarget?: Maybe<Array<Integration>>;
  /** For each objective id, returns key results visible to the current user grouped by KeyResult status — includes key results on descendant objectives */
  keyResultsGroupedByObjectiveStatus?: Maybe<Scalars['JSON']['output']>;
  /** List functional permission grants. Requires MANAGE_PERMISSIONS. */
  listFunctionalPermissionGrants?: Maybe<Functional_Permission_GrantListResult>;
  /** Platform functional-permission catalog. Requires MANAGE_PERMISSIONS. */
  listFunctionalPermissions?: Maybe<Array<Maybe<FunctionalPermission>>>;
  listGlobalPermissions?: Maybe<Array<Maybe<Global_Permission>>>;
  /** Groups for a person (Resolve_Membership KV) or groups holding an app role. Requires MANAGE_PERMISSIONS. */
  listGroupMembership?: Maybe<Group_MembershipListResult>;
  /** List locations matching the given filter criteria */
  listLocation?: Maybe<LocationListResult>;
  listMyShares?: Maybe<Array<Maybe<Record_Permission>>>;
  listMyTypePermissions?: Maybe<Array<Maybe<Type_Permission>>>;
  listPermissionTemplates?: Maybe<Array<Maybe<Permission_Template>>>;
  /** Roles on a person (Resolve_Membership KV) or a user group (Group_Membership KV). Requires MANAGE_PERMISSIONS. */
  listRoleMembership?: Maybe<Group_MembershipListResult>;
  listRoles?: Maybe<Array<Maybe<App_Role>>>;
  listShares?: Maybe<Array<Maybe<Record_Permission>>>;
  listTypePermissions?: Maybe<Array<Maybe<Type_Permission>>>;
  /** List user groups. Requires MANAGE_USER_GROUPS. */
  listUserGroups?: Maybe<UserGroupListResult>;
  /** Users in a user group, or users who hold an app role (Resolve_Membership). Requires MANAGE_PERMISSIONS. */
  listUserMembership?: Maybe<Resolve_MembershipListResult>;
  /** Every workspace in the tenant, with member and group counts. Requires MANAGE_WORKSPACES. */
  listWorkspaces?: Maybe<WorkspaceListResult>;
  /** Resolve available values for a UI lookup key */
  lookupValues?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Visible agent chat sessions for the caller — chats you own or that were shared with you (USE_AGENT_CHAT GATE; no tenant-wide list). Without agentCode it is the history page across all agents; with it, previous chats for one agent. filter/order/limit/offset match OrgList — Predicate JSON, e.g. order: "createdAt DESC". Default order is newest first. */
  myAgentChats?: Maybe<Array<Maybe<Agent_Chat_Session>>>;
  myFunctionalPermissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Key results the current user owns, created, is assigned to via position, or holds through a parent objective */
  myKeyResultList?: Maybe<Array<Maybe<KeyResult>>>;
  /** Objectives assigned to the current user's primary position, plus the parent objectives of key results assigned to that position (deduplicated) — paginated result with items, totalCount, and hasNextPage */
  myObjectiveList?: Maybe<ObjectiveListResult>;
  myPerson?: Maybe<Person>;
  /** The object-360 widget-data tree for one entity — every section/widget binding resolved. */
  objectDashboard?: Maybe<Scalars['JSON']['output']>;
  /** All objectives the current user has read access to (ACL-enforced: owned, shared via readPrincipals, or blanket type permission) — paginated result with items, totalCount, and hasNextPage */
  objectiveListAll?: Maybe<ObjectiveListResult>;
  /** Objectives assigned to the given position, plus the parent objectives of key results assigned to that position (deduplicated) — restricted to what the current user has read access to. Empty when the current user has no READ standing on Objective, or when no person currently holds positionId — paginated result with items, totalCount, hasNextPage, and hiddenObjectiveCount (position-scoped objectives the context user cannot read) */
  objectiveListForPosition?: Maybe<ObjectiveListResult>;
  /** List OKR records for the current tenant — paginated result with items, totalCount, and hasNextPage */
  okrList?: Maybe<OkrListResult>;
  /** Aggregate counts per OKR: key results, company objectives, org objectives, and unique position ids */
  okrStats: Array<OkrStats>;
  /** All open draft change sets across lanes — the standing AGENT and SYNC lanes plus any admin drafts. What the Org Structure page lists for review. */
  openOrgChangeSets?: Maybe<Array<Maybe<OrgChangeSet>>>;
  /** Operational entity types that can be populated from an external source. */
  operationalTargets?: Maybe<Array<SyncTarget>>;
  /** One change set by id, whatever its status — the review screen's fetch for a single draft (items travel inline) or a published version's detail. Errors when the id is unknown. */
  orgChangeSet: OrgChangeSet;
  /** The published change set that produced a given org version, or null. */
  orgChangeSetByVersion?: Maybe<OrgChangeSet>;
  /** The org as of a past version, as a field overlay on today's state: target document id → the fields whose value was different at that version, with their value back then. Same shape as a simulation's projected diff — overlay it on the currently rendered tree. Entities created after the version overlay as status ARCHIVE (hidden). Computed by replaying published change sets; nothing is stored per version. Empty when the version is current. */
  orgStateAtVersion: Scalars['JSON']['output'];
  /** Published change sets, newest first — the org version history list. */
  orgVersionHistory?: Maybe<Array<Maybe<OrgChangeSet>>>;
  parseImport?: Maybe<Array<Maybe<ParsedWorkbook>>>;
  /** Insights written about a person, newest first, with the ones they have dismissed left out. */
  personInsights?: Maybe<Array<Maybe<Insight>>>;
  /** A person's metric documents, newest first — every metric's trend, one entry per window. A window in which a metric was not computed simply has no key for it: absence is not zero. */
  personMetricHistory?: Maybe<Array<Maybe<MetricScore>>>;
  /** A person's most recent metric scores. One document holds every metric their model computed for that window, keyed by bare model-local name — so this is one read, not one per metric. Titles, units and categories for those names come from productivityModelDefinition(name: <the model field on this result>). */
  personMetrics?: Maybe<MetricScore>;
  /** A person's scored windows, newest first — the MGSA trend. Richer than the snapshot: these carry windowStart/windowEnd, per-dimension coverage and the component scores behind each formula. */
  personMgsaHistory?: Maybe<Array<Maybe<UserMgsaScores>>>;
  /** A person's latest MGSA snapshot — the page header. Null when they have never been scored. Carries no window and no coverage: to tell a low score from a dimension that went NA for want of components, read personMgsaHistory. */
  personMgsaScore?: Maybe<UserLatestMgsaScore>;
  /** Poll async cascade generation job status from Redis — returns a single JSON status object */
  pollCascade?: Maybe<Scalars['JSON']['output']>;
  /** Poll the async company knowledge trigger job status from Redis for the given task id — returns a JSON status object for the FE loading UI, or null when no job exists for that task id. At COMPLETED the entries are persisted; read them via CRUD filtered by the same taskId. */
  pollCompanyKnowledge?: Maybe<Scalars['JSON']['output']>;
  /** Poll the async company profile trigger job status from Redis — returns a single JSON status object, or null when no job exists for the tenant */
  pollCompanyProfile?: Maybe<Scalars['JSON']['output']>;
  /** Poll the async company source discovery job from Redis — returns a single JSON status object, or null when no job exists for the tenant. At status COMPLETED the object carries sources: [{ type, url, title }], best first, at most 8 entries. type is one of WEBSITE, LINKEDIN, CRUNCHBASE, WIKIPEDIA, NEWS, REGISTRY, OTHER — switch on it to pick the source icon; OTHER covers credible pages outside those families. Every url is an absolute, de-duplicated http(s) URL. */
  pollCompanySources?: Maybe<Scalars['JSON']['output']>;
  /** Poll async extraction result for a strategy input — null while in progress */
  pollExtraction?: Maybe<Scalars['JSON']['output']>;
  /** Poll async org assignment for an OKR — null while in progress */
  pollOrgAssignment?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Poll the async person knowledge trigger job status from Redis — returns a single JSON status object, or null when no job exists for the person */
  pollPersonKnowledge?: Maybe<Scalars['JSON']['output']>;
  /** Poll async publish job status from Redis — returns a single JSON status object */
  pollPublish?: Maybe<Scalars['JSON']['output']>;
  /** Poll async bootstrapping strategy questions for an OKR (Phase 2, no-document substitute) — null while in progress; empty list means no questions. Each question carries suggestedAnswers: 0-4 plain-text one-tap answer choices to render next to the free-text box */
  pollStrategyQuestions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Poll async clarifying questions for an OKR — null while in progress; empty list means no questions. Each question carries suggestedAnswers: 0-4 plain-text one-tap answer choices to render next to the free-text box */
  pollThemeQuestions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Poll async theme synthesis for an OKR — null while in progress */
  pollThemeSynthesis?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Poll async top-objective generation for an OKR — null while in progress */
  pollTopObjectiveGeneration?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** One enabled productivity model definition by name, e.g. the value of UserLatestMgsaScore.model. Null when the tenant has not enabled that model. */
  productivityModelDefinition?: Maybe<ProductivityModelDefinition>;
  /** The universal MGSA-centric profile: overall + per-pillar MGSA, insight feed, direct-reports table. */
  productivityProfile?: Maybe<Scalars['JSON']['output']>;
  /** Everyone enrolled in one model, a row at a time — what the enrolment screen lists. Each row carries the actor's composite doc key and what kind of actor it is, so the name is fetched with Person(id:) or JobProfile(id:) without the caller taking the key apart. Removed enrolments are not listed. Requires MANAGE_PRODUCTIVITY_MODEL. */
  productivityRoleAssignments?: Maybe<Array<Maybe<AssignedActor>>>;
  /** Every fact and signal of the tenant's enabled productivity models. */
  productivityTargets?: Maybe<Array<SyncTarget>>;
  /** Load an enriched ReportDefinitionDetail by ID */
  reportDefinition?: Maybe<Scalars['JSON']['output']>;
  /** List report definitions for the report selector, optionally sorted and paginated */
  reportDefinitions?: Maybe<ReportDefinitionListResult>;
  /** Resolve one named dataSources entry from the dashboard spec. Looks up datasourceName on the (model, kind, entityType) DashboardSpec. Optional fields replaces the Binding with a { fields: [...] } projection. Field/list Bindings return { items, totalCount, hasNextPage, page, pageSize }; aggregates and other kinds return { data, page, pageSize }. */
  resolveDataSource?: Maybe<Scalars['JSON']['output']>;
  /** Ad-hoc resolve of a dataSources map (same shape as *.dashboard.json). Collection aggregates use model/entityType/scope/filters; per-subject sources (fields/metrics/…) batch across the optional subjectIds list. Returns { data: { sourceName: resolvedValue }, subjectIds, page, pageSize, totalCount, hasNextPage }. */
  resolveDataSources?: Maybe<Scalars['JSON']['output']>;
  /** Root-level objectives within the chosen scope — objectives whose parent is null or not itself in the scoped result set — paginated result with items, totalCount, hasNextPage, and hiddenObjectiveCount; filter and order apply to the underlying fetch, limit/offset are applied after root filtering; scope defaults to ALL; positionId is required when scope is POSITIONED */
  rootLevelObjectives?: Maybe<ObjectiveListResult>;
  /** The caller's own routines — the Routines tab. A routine is a workflow (workflowCode, inputs) run on a cron as its owner. filter/order/limit/offset are the same shape as myAgentChats — Predicate JSON over the job's fields (cronExpression, tz, …), order e.g. "displayName ASC". Default order is newest first. MANAGE_ROUTINE required. */
  routines?: Maybe<RoutineListResult>;
  /** Preview what the org would look like if the selected items were published right now, without changing anything. Returns per-item verdicts (including cross-item cycles only visible in combination) and the projected field diff the UI overlays on the tree it already rendered. Omit itemIds to simulate every ACCEPTED item. */
  simulateOrgChangeSet: OrgSimulationResult;
  /** Fetch a StoredFile by its ID */
  storedFile?: Maybe<StoredFile>;
  /** List StoredFiles for the current tenant, optionally filtered by purpose */
  storedFiles?: Maybe<Array<Maybe<StoredFile>>>;
  /** This workspace's authored agents, enabled or not — the management list behind the agent-builder UI. filter/order/limit/offset are the same shape as myAgentChats — Predicate JSON over the document's fields (enabled, code, …), order e.g. "displayName ASC". Default order is newest first. USE_CUSTOM_AGENT required (own agents only). */
  tenantAgents?: Maybe<Tenant_AgentListResult>;
  /** The caller's authored workflows — the management list behind the Workflow Builder; each is also a TENANT card of workflowLibrary. A row carries the file (content) and the category/description copied from the frontmatter. filter/order/limit/offset are the same shape as myAgentChats — Predicate JSON over the document's fields (category, code, …), order e.g. "displayName ASC". Default order is newest first. USE_CUSTOM_WORKFLOW required (own only). */
  tenantWorkflows?: Maybe<Tenant_WorkflowListResult>;
  validateImport?: Maybe<ImportValidationResult>;
  /** Objectives visible to the current user via permission grants (OKR-level cascade, parent-objective cascade, or direct grants on the Objective) — paginated result with items, totalCount, and hasNextPage */
  visibleOrgObjectiveList?: Maybe<ObjectiveListResult>;
  /** Key results visible to the current user via permission grants (OKR/objective-level cascade or direct grants on the KeyResult) */
  visibleToOrgKeyResultList?: Maybe<Array<Maybe<KeyResult>>>;
  /** The workflows the caller may run — the Workflows tab. Each card carries its category (group by it), the kind of artifact one run produces, its typed inputs (render the Run-now form from them; required ones without a default must be supplied) and the suggested cron. Platform workflows and the caller's own authored ones (source TENANT), already filtered to the caller's permissions; category narrows to one group. */
  workflowLibrary?: Maybe<Array<Maybe<AgentWorkflow>>>;
  /** Runs of one workflow visible to the caller, newest first — the history under a card in the Workflows tab. Each run is an Agent_Chat_Session marked with workflowCode/workflowInputs: status, error and result read like any execute; poll it while EXECUTING. dryRun=true marks an author's test of their own document from the Workflow Builder — badge it; it filed no Actions row. */
  workflowRuns?: Maybe<Array<Maybe<Agent_Chat_Session>>>;
};


export type QueryActivityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryActivityListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryActivityPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAgent_ActionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAgent_ActionListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAgent_ActionPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAnalyticsDashboardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAnalyticsDashboardListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAnalyticsDashboardPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryArtifactArgs = {
  id: Scalars['ID']['input'];
};


export type QueryArtifactListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryArtifactPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatBucketArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChatBucketListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatBucketPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCommentListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyKnowledgeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyKnowledgeListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompanyKnowledgePaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompanyListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompanyPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDepartmentListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEdgeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEdgeListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEdgePaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEntityCodeLookupListArgs = {
  sourceEntityType: Scalars['String']['input'];
};


export type QueryExportJobHistoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExportJobHistoryListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExportJobHistoryPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGoalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGoalListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGoalPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIdentityLinkArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIdentityLinkListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIdentityLinkPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInteractionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryInteractionListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInteractionPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryJobFamilyGroupListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryJobFamilyListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryJobProfileListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryKeyResultListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryKnowledgeNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryKnowledgeNodeListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryKnowledgeNodePaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMetricArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMetricListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMetricPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMindsetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMindsetListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMindsetPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNoteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNoteListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotePaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotificationListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotificationPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotification_DeliveryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotification_DeliveryListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotification_DeliveryPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotification_OutboxArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotification_OutboxListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotification_OutboxPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotification_PreferenceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotification_PreferenceListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotification_PreferencePaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotification_TemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotification_TemplateListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotification_TemplatePaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOkrCycleListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryObjectiveListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrgListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrgRoleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrgRoleListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrgRolePaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOutcomeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOutcomeListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOutcomePaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPersonArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPersonKnowledgeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPersonKnowledgeListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPersonKnowledgePaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPersonListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPersonPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPositionListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRawChatArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRawChatListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRawChatPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryResourceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryResourceListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryResourcePaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySkillArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySkillGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySkillGroupListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySkillGroupPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySkillListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySkillPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTaskListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTaskPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTenantOntologyPackArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTenantOntologyPackListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTenantOntologyPackPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserDashboardPreferenceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserDashboardPreferenceListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserDashboardPreferencePaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserMetricScoreArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserMetricScoreListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserMetricScorePaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserTaskListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWorkActivityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkActivityListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWorkActivityPaginatedListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAgentActionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAgentChatArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryAgentChatCatalogArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAgentChatSummaryArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryAgentDraftArgs = {
  draftId: Scalars['ID']['input'];
};


export type QueryAggregateArgs = {
  aggregations?: InputMaybe<Array<AggregationInput>>;
  entityType: Scalars['String']['input'];
  filter?: InputMaybe<Scalars['JSON']['input']>;
  groupBy?: InputMaybe<Array<Scalars['String']['input']>>;
  having?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllKeyResultListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAnalyticsViewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAnalyticsViewsArgs = {
  reportDefinitionId: Scalars['ID']['input'];
};


export type QueryAuditLogForEntityArgs = {
  entityType: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  recordId: Scalars['String']['input'];
};


export type QueryCheckInListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCollectionViewArgs = {
  entityType: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSON']['input']>;
  model: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  windowDays?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDashboardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDashboardEntriesArgs = {
  personId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDashboardLayoutArgs = {
  entityType: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  model: Scalars['String']['input'];
};


export type QueryDashboardsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DashboardType>;
};


export type QueryExecuteReportArgs = {
  input: Scalars['JSON']['input'];
};


export type QueryExportJobArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExportJobsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  reportDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  sourceEntityId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExportStatusArgs = {
  triggerId: Scalars['ID']['input'];
};


export type QueryFileDownloadInfoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryImportJobStatusArgs = {
  triggerId: Scalars['ID']['input'];
};


export type QueryInitiativeListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIntegrationConnectionsArgs = {
  sourceType: Scalars['String']['input'];
};


export type QueryIntegrationsForTargetArgs = {
  kind: Scalars['String']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  target: Scalars['String']['input'];
};


export type QueryKeyResultsGroupedByObjectiveStatusArgs = {
  objectiveIds: Array<Scalars['ID']['input']>;
};


export type QueryListFunctionalPermissionGrantsArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListGroupMembershipArgs = {
  entityType: Scalars['String']['input'];
  filter?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListLocationArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListMySharesArgs = {
  recordIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  resourceType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListMyTypePermissionsArgs = {
  resourceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryListPermissionTemplatesArgs = {
  resourceType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListRoleMembershipArgs = {
  entityType: Scalars['String']['input'];
  filter?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListSharesArgs = {
  entityType: Scalars['String']['input'];
  recordId: Scalars['String']['input'];
};


export type QueryListTypePermissionsArgs = {
  resourceType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListUserGroupsArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListUserMembershipArgs = {
  entityType: Scalars['String']['input'];
  filter?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListWorkspacesArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLookupValuesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  lookup: Scalars['JSON']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  skipBy?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyAgentChatsArgs = {
  agentCode?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyKeyResultListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyObjectiveListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryObjectDashboardArgs = {
  entityId: Scalars['ID']['input'];
  entityType: Scalars['String']['input'];
  model: Scalars['String']['input'];
  windowDays?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryObjectiveListAllArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryObjectiveListForPositionArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  positionId: Scalars['ID']['input'];
};


export type QueryOkrListArgs = {
  excludeArchivedCycles?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOkrStatsArgs = {
  okrIds: Array<Scalars['ID']['input']>;
};


export type QueryOrgChangeSetArgs = {
  changeSetId: Scalars['ID']['input'];
};


export type QueryOrgChangeSetByVersionArgs = {
  version: Scalars['Int']['input'];
};


export type QueryOrgStateAtVersionArgs = {
  version: Scalars['Int']['input'];
};


export type QueryOrgVersionHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryParseImportArgs = {
  fileIds: Array<Scalars['ID']['input']>;
};


export type QueryPersonInsightsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  personId: Scalars['ID']['input'];
};


export type QueryPersonMetricHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  personId: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryPersonMetricsArgs = {
  personId: Scalars['ID']['input'];
};


export type QueryPersonMgsaHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  personId: Scalars['ID']['input'];
  since?: InputMaybe<Scalars['Long']['input']>;
};


export type QueryPersonMgsaScoreArgs = {
  personId: Scalars['ID']['input'];
};


export type QueryPollCascadeArgs = {
  okrId: Scalars['ID']['input'];
};


export type QueryPollCompanyKnowledgeArgs = {
  taskId: Scalars['ID']['input'];
};


export type QueryPollExtractionArgs = {
  strategyInputId: Scalars['ID']['input'];
};


export type QueryPollOrgAssignmentArgs = {
  okrId: Scalars['ID']['input'];
};


export type QueryPollPersonKnowledgeArgs = {
  personId: Scalars['ID']['input'];
};


export type QueryPollPublishArgs = {
  okrId: Scalars['ID']['input'];
};


export type QueryPollStrategyQuestionsArgs = {
  okrId: Scalars['ID']['input'];
};


export type QueryPollThemeQuestionsArgs = {
  okrId: Scalars['ID']['input'];
};


export type QueryPollThemeSynthesisArgs = {
  okrId: Scalars['ID']['input'];
};


export type QueryPollTopObjectiveGenerationArgs = {
  okrId: Scalars['ID']['input'];
};


export type QueryProductivityModelDefinitionArgs = {
  name: Scalars['String']['input'];
};


export type QueryProductivityProfileArgs = {
  personId?: InputMaybe<Scalars['ID']['input']>;
  windowDays?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductivityRoleAssignmentsArgs = {
  model: Scalars['String']['input'];
};


export type QueryReportDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportDefinitionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryResolveDataSourceArgs = {
  controls?: InputMaybe<Scalars['JSON']['input']>;
  datasourceName: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filters?: InputMaybe<Scalars['JSON']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  model: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  subjectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  windowDays?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryResolveDataSourcesArgs = {
  controls?: InputMaybe<Scalars['JSON']['input']>;
  dataSources: Scalars['JSON']['input'];
  entityType: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSON']['input']>;
  model: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  subjectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  windowDays?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRootLevelObjectivesArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  positionId?: InputMaybe<Scalars['ID']['input']>;
  scope?: InputMaybe<ObjectiveScope>;
};


export type QueryRoutinesArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySimulateOrgChangeSetArgs = {
  changeSetId: Scalars['ID']['input'];
  itemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryStoredFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStoredFilesArgs = {
  purposeEntityId?: InputMaybe<Scalars['ID']['input']>;
  purposeType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTenantAgentsArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTenantWorkflowsArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryValidateImportArgs = {
  sheets: Scalars['JSON']['input'];
};


export type QueryVisibleOrgObjectiveListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVisibleToOrgKeyResultListArgs = {
  filter?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWorkflowLibraryArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
};


export type QueryWorkflowRunsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  workflowCode: Scalars['String']['input'];
};

/** Raw chat message archived from messaging platform */
export type RawChat = BaseEntity & {
  __typename?: 'RawChat';
  actorIdentity?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  channelId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  eventSubType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  messageId?: Maybe<Scalars['String']['output']>;
  messageText?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  threadId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type RawChatInput = {
  actorIdentity?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  channelId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  eventSubType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  messageId?: InputMaybe<Scalars['String']['input']>;
  messageText?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  threadId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a RawChatList query */
export type RawChatListResult = {
  __typename?: 'RawChatListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<RawChat>>>;
  /** Total number of RawChat records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Record_Permission = BaseEntity & {
  __typename?: 'Record_Permission';
  actions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  actor?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  recordId?: Maybe<BaseEntity>;
  resourceType?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Permission_Template>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type Record_PermissionInput = {
  actions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actor?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  recordId?: InputMaybe<Scalars['ID']['input']>;
  resourceType?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

export type ReportDefinition = BaseEntity & {
  __typename?: 'ReportDefinition';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  defaultFilter?: Maybe<Scalars['JSON']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  name?: Maybe<Scalars['String']['output']>;
  participatingEntities?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  primaryEntity?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

/** Paginated result of a reportDefinitions query */
export type ReportDefinitionListResult = {
  __typename?: 'ReportDefinitionListResult';
  /** Whether more report definitions exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  /** Report definitions on this page (id, name, description) */
  items?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  /** Total report definitions */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** One hiring event opened against a JobProfile; headcount is derived from the Positions attached to it */
export type Requisition = BaseEntity & {
  __typename?: 'Requisition';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  hiringManagerPositionId?: Maybe<Position>;
  id: Scalars['ID']['output'];
  jobProfileId?: Maybe<JobProfile>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  status?: Maybe<Scalars['String']['output']>;
  targetStartDate?: Maybe<Scalars['Long']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
  workMode?: Maybe<Scalars['String']['output']>;
};

export type RequisitionInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  hiringManagerPositionId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobProfileId?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  targetStartDate?: InputMaybe<Scalars['Long']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
  workMode?: InputMaybe<Scalars['String']['input']>;
};

export type Resolve_Membership = BaseEntity & {
  __typename?: 'Resolve_Membership';
  appRole?: Maybe<App_Role>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Person>;
  version?: Maybe<Scalars['Long']['output']>;
};

/** Paginated result of a Resolve_MembershipList query */
export type Resolve_MembershipListResult = {
  __typename?: 'Resolve_MembershipListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Resolve_Membership>>>;
  /** Total number of Resolve_Membership records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** LMS Resource entity representing a hierarchical reusable asset */
export type Resource = BaseEntity & {
  __typename?: 'Resource';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  parentContentId?: Maybe<Resource>;
  parentSurveyId?: Maybe<Resource>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type ResourceInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  parentContentId?: InputMaybe<Scalars['ID']['input']>;
  parentSurveyId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a ResourceList query */
export type ResourceListResult = {
  __typename?: 'ResourceListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Resource>>>;
  /** Total number of Resource records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** One routine — a workflow with saved inputs, run on a cron as its owner */
export type Routine = {
  __typename?: 'Routine';
  createdAt?: Maybe<Scalars['Long']['output']>;
  /** The person who first created this routine */
  createdBy?: Maybe<Person>;
  cron?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** The inputs the routine runs with, by name — what the Run-now form would have sent */
  inputs?: Maybe<Scalars['JSON']['output']>;
  /** The run record of the routine's latest firing — EXECUTED with its result, or FAILED with its reason — or null if it has not fired yet or the caller cannot see the owner's runs */
  lastRun?: Maybe<Agent_Chat_Session>;
  /** When the routine last fired, or null if it never has */
  lastRunAt?: Maybe<Scalars['Long']['output']>;
  /** When the routine fires next, or null if the scheduler has not yet planned it or it is DEAD */
  nextRunAt?: Maybe<Scalars['Long']['output']>;
  /** The person the routine runs as — the one who created it */
  owner?: Maybe<Person>;
  routineId: Scalars['ID']['output'];
  /** The scheduler's view of the routine: READY (waiting for its next tick), RUNNING, FAILED (the last firing's plumbing failed; it retries), DEAD (retries exhausted; save it again to revive it), or null before the scheduler has first seen it */
  status?: Maybe<Scalars['String']['output']>;
  tz?: Maybe<Scalars['String']['output']>;
  /** The workflow's card, or null if the code no longer resolves or the caller may not run it */
  workflow?: Maybe<AgentWorkflow>;
  /** The workflow this routine runs */
  workflowCode: Scalars['String']['output'];
};

/** Paginated result of a routines query */
export type RoutineListResult = {
  __typename?: 'RoutineListResult';
  /** Whether more routines exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Routine>>>;
  /** Total number of routines matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Global skill registry entry */
export type Skill = BaseEntity & {
  __typename?: 'Skill';
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

/** Global skill group registry entry */
export type SkillGroup = BaseEntity & {
  __typename?: 'SkillGroup';
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  skillWeights?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type SkillGroupInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  skillWeights?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a SkillGroupList query */
export type SkillGroupListResult = {
  __typename?: 'SkillGroupListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<SkillGroup>>>;
  /** Total number of SkillGroup records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SkillInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a SkillList query */
export type SkillListResult = {
  __typename?: 'SkillListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Skill>>>;
  /** Total number of Skill records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type StoredFile = {
  __typename?: 'StoredFile';
  bucket?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  encrypted?: Maybe<Scalars['Boolean']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  objectKey?: Maybe<Scalars['String']['output']>;
  originalName?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  purposeEntityId?: Maybe<Scalars['ID']['output']>;
  purposeType?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Long']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  uploadedAt?: Maybe<Scalars['Long']['output']>;
};

/** A strategy input attached to an OKR — document, pasted text, or previous-cycle OKR reference that feeds the AI generation pipeline */
export type StrategyInput = BaseEntity & {
  __typename?: 'StrategyInput';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  extractionResult?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  okrId?: Maybe<Okr>;
  sourceDate?: Maybe<Scalars['Long']['output']>;
  sourceRef?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type SyncTarget = {
  __typename?: 'SyncTarget';
  displayName: Scalars['String']['output'];
  inputSchema?: Maybe<Array<TargetField>>;
  kind: Scalars['String']['output'];
  model?: Maybe<Scalars['String']['output']>;
  target: Scalars['String']['output'];
};

export type TargetField = {
  __typename?: 'TargetField';
  description?: Maybe<Scalars['String']['output']>;
  multiple: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

/** Task entity for tracking work items and action items */
export type Task = BaseEntity & {
  __typename?: 'Task';
  SUBJECT_PREDICATE?: Maybe<Scalars['String']['output']>;
  activityId?: Maybe<Activity>;
  assigneePersonIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  dueAt?: Maybe<Scalars['Long']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  relatedId?: Maybe<Scalars['String']['output']>;
  relatedType?: Maybe<Scalars['String']['output']>;
  sourceTool?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subjectIds?: Maybe<Array<Maybe<BaseEntity>>>;
  taskType?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type TaskInput = {
  SUBJECT_PREDICATE?: InputMaybe<Scalars['String']['input']>;
  activityId?: InputMaybe<Scalars['ID']['input']>;
  assigneePersonIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  dueAt?: InputMaybe<Scalars['Long']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  relatedId?: InputMaybe<Scalars['String']['input']>;
  relatedType?: InputMaybe<Scalars['String']['input']>;
  sourceTool?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subjectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  taskType?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a TaskList query */
export type TaskListResult = {
  __typename?: 'TaskListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Task>>>;
  /** Total number of Task records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A tenant's enabled ontology pack (with optional inline YAML override) */
export type TenantOntologyPack = BaseEntity & {
  __typename?: 'TenantOntologyPack';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  defaultPack?: Maybe<Scalars['Boolean']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  packName?: Maybe<Scalars['String']['output']>;
  sources?: Maybe<Scalars['JSON']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
  yaml?: Maybe<Scalars['String']['output']>;
};

export type TenantOntologyPackInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  defaultPack?: InputMaybe<Scalars['Boolean']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  packName?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Scalars['JSON']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
  yaml?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a TenantOntologyPackList query */
export type TenantOntologyPackListResult = {
  __typename?: 'TenantOntologyPackListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<TenantOntologyPack>>>;
  /** Total number of TenantOntologyPack records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** One tenant-authored conversational agent — the JSON spec, stored and editable */
export type Tenant_Agent = BaseEntity & {
  __typename?: 'Tenant_Agent';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  spec?: Maybe<Scalars['JSON']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

/** Paginated result of a Tenant_AgentList query */
export type Tenant_AgentListResult = {
  __typename?: 'Tenant_AgentListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Tenant_Agent>>>;
  /** Total number of Tenant_Agent records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** One tenant-authored workflow — the markdown file, stored, private to its author */
export type Tenant_Workflow = BaseEntity & {
  __typename?: 'Tenant_Workflow';
  category?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

/** Paginated result of a Tenant_WorkflowList query */
export type Tenant_WorkflowListResult = {
  __typename?: 'Tenant_WorkflowListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Tenant_Workflow>>>;
  /** Total number of Tenant_Workflow records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Type_Permission = BaseEntity & {
  __typename?: 'Type_Permission';
  actions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  actor?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  resourceType?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type Type_PermissionInput = {
  actions?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  actor?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  resourceType?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

export type User = BaseEntity & {
  __typename?: 'User';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

/** Per-user dashboard layout/filter override */
export type UserDashboardPreference = BaseEntity & {
  __typename?: 'UserDashboardPreference';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  model?: Maybe<Scalars['String']['output']>;
  overrides?: Maybe<Scalars['JSON']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Person>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type UserDashboardPreferenceInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  overrides?: InputMaybe<Scalars['JSON']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a UserDashboardPreferenceList query */
export type UserDashboardPreferenceListResult = {
  __typename?: 'UserDashboardPreferenceListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<UserDashboardPreference>>>;
  /** Total number of UserDashboardPreference records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UserGroup = BaseEntity & {
  __typename?: 'UserGroup';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  scope?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  systemDefined?: Maybe<Scalars['Boolean']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type UserGroupInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  systemDefined?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated result of a UserGroupList query */
export type UserGroupListResult = {
  __typename?: 'UserGroupListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<UserGroup>>>;
  /** Total number of UserGroup records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UserInput = {
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a UserList query */
export type UserListResult = {
  __typename?: 'UserListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<User>>>;
  /** Total number of User records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Per-user metric value computed for a time window */
export type UserMetricScore = BaseEntity & {
  __typename?: 'UserMetricScore';
  computedAt?: Maybe<Scalars['Long']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobRunId?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  metricId?: Maybe<Metric>;
  target?: Maybe<Scalars['Float']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Person>;
  value?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
  windowEnd?: Maybe<Scalars['Long']['output']>;
  windowStart?: Maybe<Scalars['Long']['output']>;
};

export type UserMetricScoreInput = {
  computedAt?: InputMaybe<Scalars['Long']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobRunId?: InputMaybe<Scalars['String']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  metricId?: InputMaybe<Scalars['ID']['input']>;
  target?: InputMaybe<Scalars['Float']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
  windowEnd?: InputMaybe<Scalars['Long']['input']>;
  windowStart?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a UserMetricScoreList query */
export type UserMetricScoreListResult = {
  __typename?: 'UserMetricScoreListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<UserMetricScore>>>;
  /** Total number of UserMetricScore records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A user's MGSA scores for one window */
export type UserMgsaScores = BaseEntity & {
  __typename?: 'UserMgsaScores';
  SEP?: Maybe<Scalars['String']['output']>;
  componentScores?: Maybe<Scalars['JSON']['output']>;
  computedAt?: Maybe<Scalars['Long']['output']>;
  coverage?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  goalAvgScore?: Maybe<Scalars['Float']['output']>;
  goalScores?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  jobRunId?: Maybe<Scalars['String']['output']>;
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  mindsetAvgScore?: Maybe<Scalars['Float']['output']>;
  mindsetScores?: Maybe<Scalars['JSON']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  overallScore?: Maybe<Scalars['Float']['output']>;
  roleId?: Maybe<Scalars['String']['output']>;
  skillAvgScore?: Maybe<Scalars['Float']['output']>;
  skillScores?: Maybe<Scalars['JSON']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Person>;
  version?: Maybe<Scalars['Long']['output']>;
  windowEnd?: Maybe<Scalars['Long']['output']>;
  windowStart?: Maybe<Scalars['Long']['output']>;
  workActivityAvgScore?: Maybe<Scalars['Float']['output']>;
  workActivityScores?: Maybe<Scalars['JSON']['output']>;
};

/** Global work activity registry entry */
export type WorkActivity = BaseEntity & {
  __typename?: 'WorkActivity';
  category?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

export type WorkActivityInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Long']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Long']['input']>;
  deletedBy?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityId?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastModifiedAt?: InputMaybe<Scalars['Long']['input']>;
  lastModifiedBy?: InputMaybe<Scalars['ID']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Long']['input']>;
};

/** Paginated result of a WorkActivityList query */
export type WorkActivityListResult = {
  __typename?: 'WorkActivityListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<WorkActivity>>>;
  /** Total number of WorkActivity records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Workspace = BaseEntity & {
  __typename?: 'Workspace';
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  /** User groups that live in this workspace. */
  groupCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  /** People who are members of this workspace. */
  memberCount?: Maybe<Scalars['Int']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Long']['output']>;
};

/** Paginated result of a WorkspaceList query */
export type WorkspaceListResult = {
  __typename?: 'WorkspaceListResult';
  /** Whether more records exist beyond this page */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<Maybe<Workspace>>>;
  /** Total number of Workspace records matching the filter */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Per-user latest MGSA score snapshot */
export type UserLatestMgsaScore = BaseEntity & {
  __typename?: 'userLatestMgsaScore';
  computedAt?: Maybe<Scalars['Long']['output']>;
  createdAt?: Maybe<Scalars['Long']['output']>;
  createdBy?: Maybe<Person>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  deletedAt?: Maybe<Scalars['Long']['output']>;
  deletedBy?: Maybe<Person>;
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  goalAvgScore?: Maybe<Scalars['Float']['output']>;
  goalScores?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  lastModifiedAt?: Maybe<Scalars['Long']['output']>;
  lastModifiedBy?: Maybe<Person>;
  metricScores?: Maybe<Scalars['JSON']['output']>;
  mindsetAvgScore?: Maybe<Scalars['Float']['output']>;
  mindsetScores?: Maybe<Scalars['JSON']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  overallScore?: Maybe<Scalars['Float']['output']>;
  roleId?: Maybe<Scalars['String']['output']>;
  skillAvgScore?: Maybe<Scalars['Float']['output']>;
  skillScores?: Maybe<Scalars['JSON']['output']>;
  tenantId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Person>;
  version?: Maybe<Scalars['Long']['output']>;
  workActivityAvgScore?: Maybe<Scalars['Float']['output']>;
  workActivityScores?: Maybe<Scalars['JSON']['output']>;
};
